var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.333,
    height: 86.682,
    viewBox: "0 0 78.333 86.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 78.333,
    height: 86.682,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(13 12.623)",
    fill: "#704141"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 57.57,
    height: 58.544,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-355 -73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(355 73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M39.167,0A39.166,39.166,0,1,0,78.334,39.167,39.167,39.167,0,0,0,39.167,0m0,64.818A25.652,25.652,0,1,1,64.819,39.167,25.652,25.652,0,0,1,39.167,64.819",
    transform: "translate(0 -0.001)",
    fill: "#f8e0dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M9.192,80.714l.31-1.748,4.509-.958L10.1,75.573l.309-1.74,6.076,1.079-.263,1.48-3.644-.647,3.4,2.006-.212,1.194-3.9.719,3.652.648-.263,1.48Z",
    transform: "translate(-5.52 -44.34)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M21.554,61.856l-.936,2.1.845.78-.639,1.437L16.1,61.629,16.8,60.04l6.543.469L22.7,61.961Zm-3.591-.338,1.756,1.608.618-1.389Z",
    transform: "translate(-9.666 -36.057)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M26.019,44.426l.865-1.229,3.435,2.418a1.863,1.863,0,0,1,.491,2.829,1.978,1.978,0,0,1-2.978.536l.86-1.222c.431.3.771.263.994-.053.207-.295.142-.6-.232-.862Z",
    transform: "translate(-15.625 -25.942)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M39.824,36.624a3.159,3.159,0,1,1,.121-4.466,3.1,3.1,0,0,1-.121,4.466m-.941-1a1.8,1.8,0,1,0-2.419-.181,1.613,1.613,0,0,0,2.419.181",
    transform: "translate(-20.694 -18.699)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M49.241,21.285a1.976,1.976,0,0,1,2.946.482A1.8,1.8,0,0,1,51.943,24l2.486,1.348-1.45.881-2.306-1.324-.308.187,1.21,1.99-1.284.781-3.2-5.272Zm.573,1.112-.8.484.794,1.307.8-.484a.767.767,0,1,0-.795-1.307",
    transform: "translate(-28.277 -12.522)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M72.388,18.51c-1.275.369-2.455.025-2.844-1.162l1.537-.445a.707.707,0,0,0,.93.463c.422-.122.631-.412.531-.758-.318-1.1-3.11.352-3.7-1.755-.325-1.123.414-2.014,1.655-2.374,1.291-.374,2.347.016,2.733,1.13l-1.562.452a.668.668,0,0,0-.862-.419.547.547,0,0,0-.451.717c.3,1.03,3.093-.283,3.667,1.7a1.986,1.986,0,0,1-1.633,2.449",
    transform: "translate(-41.295 -7.412)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M83.918,9.575l1.5-.129.318,3.676c.063.727.458,1.116,1.167,1.055a1.014,1.014,0,0,0,.987-1.24L87.568,9.26l1.5-.129.317,3.667a2.423,2.423,0,0,1-2.39,2.763,2.365,2.365,0,0,1-2.757-2.319Z",
    transform: "translate(-50.396 -5.484)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M103.785,9.547c1.5.17,2.156,1.12,2.036,2.185a1.8,1.8,0,0,1-1.563,1.619l1.14,2.588-1.685-.191L102.7,13.29l-.358-.04-.262,2.314-1.494-.169.693-6.132Zm-.227,1.231-.926-.105-.172,1.52.926.105a.717.717,0,0,0,.908-.676c.052-.454-.177-.781-.736-.844",
    transform: "translate(-60.405 -5.563)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M119.787,14l-2.18-.654-.358,1.2,1.927.578-.333,1.111-1.928-.578-.389,1.3,2.18.654-.346,1.153-3.619-1.085,1.772-5.909,3.619,1.085Z",
    transform: "translate(-68.907 -7.066)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M128.8,23.705c-1.186-.6-1.816-1.651-1.294-2.786l1.429.719a.707.707,0,0,0,.367.972c.392.2.743.127.9-.195.513-1.02-2.519-1.857-1.52-3.8.525-1.044,1.673-1.195,2.827-.614,1.2.6,1.709,1.607,1.235,2.687l-1.452-.731a.668.668,0,0,0-.348-.893.547.547,0,0,0-.818.218c-.482.958,2.459,1.9,1.532,3.742a1.987,1.987,0,0,1-2.863.685",
    transform: "translate(-76.46 -10.606)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M142.544,29.319l-1.84-1.443-1.568,2-1.183-.928,3.808-4.856,1.183.928-1.492,1.9,1.84,1.443,1.492-1.9,1.183.928-3.808,4.856-1.183-.928Z",
    transform: "translate(-82.847 -14.468)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M156.17,47.507c-.786-1.069-.87-2.294.109-3.069l.948,1.288a.707.707,0,0,0-.114,1.032c.26.354.6.45.894.237.92-.677-1.4-2.8.37-4.078.942-.692,2.032-.306,2.8.734.8,1.083.8,2.207-.117,2.954l-.963-1.309a.667.667,0,0,0,.1-.953.547.547,0,0,0-.828-.176c-.863.635,1.332,2.8-.331,4.027a1.985,1.985,0,0,1-2.861-.687",
    transform: "translate(-93.422 -25.564)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M168.357,54.6l.638,1.36-3.341,1.567a1,1,0,0,0-.587,1.459,1.013,1.013,0,0,0,1.5.5l3.341-1.567.638,1.36-3.333,1.563a2.422,2.422,0,0,1-3.418-1.289,2.365,2.365,0,0,1,1.225-3.389Z",
    transform: "translate(-98.19 -32.787)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M174.5,74.034a1.976,1.976,0,0,1-1.359,2.659,1.8,1.8,0,0,1-2.055-.916l-2.043,1.955-.4-1.649,1.964-1.792-.084-.35-2.265.544-.352-1.461,6-1.442Zm-1.234.206-.218-.906-1.487.358.218.906a.767.767,0,1,0,1.487-.358",
    transform: "translate(-100.836 -42.987)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 6.17,
    height: 1.503,
    transform: "translate(68.236 35.712) rotate(-5.26)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M30.214,139.567l2.479,3.159-.947.743-1.551-1.977-1.023.8,1.161,1.479-.92.721-1.161-1.479-1.963,1.541-.928-1.182Z",
    transform: "translate(-15.231 -83.816)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M38.514,157.1a3.159,3.159,0,1,1,4.454-.346,3.1,3.1,0,0,1-4.454.346m.893-1.04a1.8,1.8,0,1,0-.073-2.425,1.613,1.613,0,0,0,.073,2.425",
    transform: "translate(-22.447 -90.988)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M54.724,159.654l1.325.709-1.74,3.256a1,1,0,0,0,.4,1.521,1.013,1.013,0,0,0,1.5-.5l1.741-3.257,1.325.709-1.737,3.248a2.424,2.424,0,0,1-3.512,1.013,2.367,2.367,0,0,1-1.046-3.451Z",
    transform: "translate(-31.6 -95.879)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M74.227,168.177l-1.677,5.935L71.1,173.7,69.72,169.36l-1.035,3.661-1.446-.409,1.677-5.935,1.446.409,1.379,4.361,1.039-3.677Z",
    transform: "translate(-40.381 -100.097)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M91.944,174.2a2.984,2.984,0,0,1-3.4,2.893l-2.307-.133.355-6.157,2.306.133a2.979,2.979,0,0,1,3.05,3.264m-3.427,1.589a1.792,1.792,0,1,0,.207-3.579l-.711-.041-.206,3.579Z",
    transform: "translate(-51.786 -102.572)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M108.219,175.058l-2.274.356-.2,1.134-1.553.243,1.251-6.438,1.718-.269,3.159,5.748-1.571.246Zm-1.666-3.2-.4,2.348,1.5-.235Z",
    transform: "translate(-62.573 -102.142)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M117.79,166.381l4.478-1.651.417,1.13-1.534.566,1.719,4.66-1.41.52-1.719-4.66-1.534.566Z",
    transform: "translate(-70.738 -98.927)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 1.503,
    height: 6.172,
    transform: "matrix(0.882, -0.471, 0.471, 0.882, 52.272, 65.345)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M144.362,160.037a3.16,3.16,0,1,1,.581-4.432,3.105,3.105,0,0,1-.581,4.432m-.834-1.089a1.8,1.8,0,1,0-2.388-.429,1.613,1.613,0,0,0,2.388.429",
    transform: "translate(-83.62 -92.686)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M153.529,139.523l4.746,3.941-.96,1.156-4.533-.5,2.927,2.431-.96,1.156L150,143.768l.96-1.156,4.546.509-2.94-2.442Z",
    transform: "translate(-90.084 -83.789)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(355 73)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(384.382 411.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-375 -397.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M8.174,423.385a4.022,4.022,0,0,1,.321-.478c.342-.382.7-.75,1.052-1.124l0-.006a2.136,2.136,0,0,0-.521,2.37,1.77,1.77,0,0,0,1.54.958c.011,0,.021-.009.032-.011.321-.059.787-.011.927-.2.172-.236.088-.67.072-1.017,0-.055-.25-.17-.344-.139-.416.14-.887.168-.972-.294-.064-.348.228-.76.353-1.147.03-.094.071-.252.026-.292-.243-.22-.511-.413-.962-.766l11-4.157v.431a4.242,4.242,0,0,0,.345-.27,6.928,6.928,0,0,0,1.154-1.16,13.162,13.162,0,0,0,.843-1.88,1.108,1.108,0,0,0,.049-.23c.31.623.594,1.246.924,1.845.646,1.173,1.3,2.343,1.984,3.5,1.123,1.9,2.311,3.756,3.39,5.676a17.253,17.253,0,0,1,.857,2.34c.209.548.459,1.08.7,1.614.03.065.144.151.19.136.066-.021.124-.119.154-.2.832-2.134,1.676-4.264,2.482-6.408.3-.81.482-1.669.793-2.477a14.223,14.223,0,0,1,.928-1.873,7.055,7.055,0,0,0,1.062-3.4,2.425,2.425,0,0,1,.206.565c.13,1.258.228,2.52.364,3.778a6.483,6.483,0,0,0,.262.994c.021.075.086.2.068.213-.644.464.168,1.119-.3,1.644,1.928.511,3.793,1.015,5.072,2.641l.122-.118a7.59,7.59,0,0,0-.56-.818,8.277,8.277,0,0,0-.649-.537.908.908,0,0,1-.142-.3c.092-.01.183-.021.275-.029.128-.011.257-.019.444-.033l-.205.366.651.242c-.233-.783-.447-1.486-.65-2.191a3.377,3.377,0,0,1-.068-.441c.125.042.253.077.375.128q3.107,1.294,6.212,2.595c.457.192.9.427,1.351.627a1.454,1.454,0,0,0,.385.057,1.272,1.272,0,0,1,.011-.347c.062-.2.187-.382.232-.584a3.2,3.2,0,0,0,.044-.57l-.729.239c-.032-.105-.064-.21-.094-.317l.028-.007a.084.084,0,0,0,.017-.011l-.051.021c.322-.106.645-.206.964-.319.123-.044.321-.1.333-.179a.626.626,0,0,0-.132-.421,7.11,7.11,0,0,0-.538-.583l0,0,1.114.688v1.6l-.12.022a4.471,4.471,0,0,0-.141-.552c-.032-.083-.138-.138-.21-.206a1.774,1.774,0,0,0-.1.268,2.236,2.236,0,0,1-.042.357c-.256.646.349.795.647,1.116.009.01.228-.106.232-.17.027-.542.025-1.085.036-1.627a1.229,1.229,0,0,1,.126-.577c-.118,1.352-.252,2.694.93,3.751l-.24.1c-.2-.3-.385-.6-.6-.883a1.367,1.367,0,0,0-.31-.234,1.111,1.111,0,0,0-.077.352c.034.3.1.59.159.9l.384-.213c.064.134.123.272.194.4.156.29.321.575.477.865.191.354.36.722.571,1.064a5.073,5.073,0,0,0,.487.58c0,.039.008.076,0-.005l0,.009-1.073-2.6.123-.058c.4.831.812,1.655,1.19,2.495.2.451.229,1.032.534,1.379.992,1.129,1.125,2.562,1.428,3.9.342,1.513.349,3.1.64,4.627.38,1.99.9,3.954,1.354,5.929a1.189,1.189,0,0,1-.272.065q-28.513,0-57.026,0A1.192,1.192,0,0,1,0,444.309c.317-1.042.7-2.07.937-3.13.523-2.379.863-4.8,1.484-7.156.485-1.839,1.286-3.594,1.938-5.39a15.142,15.142,0,0,1,2.46-3.948,2.762,2.762,0,0,1,.931-.572,2.663,2.663,0,0,0,.369-.4.971.971,0,0,0,.049-.331l.007.007M31,440.778l-.008-.008c.208.021.54.128.6.045.122-.177.209-.586.117-.66a1.742,1.742,0,0,0-.88-.332c-.093-.01-.344.363-.309.507.044.178.312.3.483.448M53.92,433.59l.718-.563.135.405-.492.12a1.94,1.94,0,0,1,.243.355,2.019,2.019,0,0,1,.087.446c.016.1.021.2.033.3.024.185.049.369.074.553-.119-.1-.234-.2-.358-.3a3.456,3.456,0,0,0-.354-.226.25.25,0,0,0-.085.119,9.213,9.213,0,0,0-.06,1.027c0,.13.122.363.2.368.408.025.979.292,1.054-.422a9.569,9.569,0,0,0-.021-1.581c-.011-.185-.667-.349-.007-.562.038-.012.051-.188.031-.277-.1-.458-.222-.911-.325-1.368a4.684,4.684,0,0,1-.06-.488,2.433,2.433,0,0,0-.661.281c-.149.124-.195.369-.3.552-.068.12-.137.281-.247.328a1.849,1.849,0,0,0-1.092,1.59c-.085.456-.142.744.2,1.033a1.184,1.184,0,0,0,.594.35c.129,0,.35-.284.386-.468.112-.587-.046-1.008-.86-.827a3.992,3.992,0,0,1,.408-.793,1.038,1.038,0,0,1,.548-.252c.048-.011.146.2.22.3l-.655.031a2.455,2.455,0,0,0,.831.685c.084.046.216.006.326.005-.068-.1-.137-.192-.2-.289l-.3-.439m-8.345,3.352q0,.111,0,.222c.365,0,.734-.029,1.1.007.455.045.868.323.975-.528.091-.728.071-1.033-.684-1.069-.145-.007-.324.08-.428.02-.147-.083-.332-.261-.336-.4-.01-.344.092-.69.11-1.037a.36.36,0,0,0-.209-.277c-.383-.082-.774-.128-1.163-.175-1.6-.192-3.195-.385-4.794-.557-.11-.012-.341.147-.341.225,0,.422.06.843.1,1.265,0,0,.042,0,.065,0,.747.072,1.493.147,2.24.216.319.029.623.044.557-.442a1.68,1.68,0,0,1,.065-.533.258.258,0,0,1,.119-.142c.016-.01.118.058.116.088-.016.426-.042.852-.066,1.278-.193-.012-.388-.014-.58-.039-1.244-.162-2.486-.336-3.731-.485-.15-.018-.448.079-.453.143-.045.493-.035.991-.034,1.488a1.027,1.027,0,0,0,.161.019c.575.053,1.15.1,1.724.162.443.048.885.113,1.327.173.957.129,1.91.294,2.87.375a6.368,6.368,0,0,0,1.305-.152l.642-.084.01.176-.664.069m-34.81-15.93-.016.164a6.73,6.73,0,0,1,.6.335c.088.061.18.273.191.267a6.365,6.365,0,0,0,.738-.444c.064-.045.072-.169.106-.256.067.037.169.06.192.115.039.1.077.272.031.309a7.238,7.238,0,0,1-.747.5,2.439,2.439,0,0,1-.334.144,1.638,1.638,0,0,0,.378.2c.645.149,1.3.275,1.942.42.193.043.378.12.567.181-.149-.182-.314-.355-.444-.55a1.438,1.438,0,0,1-.209-.491c-.009-.042.181-.119.273-.189.137-.1.269-.214.4-.322-.18-.019-.36-.032-.539-.057-.325-.045-.9-.037-.932-.155-.2-.844-.515-.307-.845-.145a1.362,1.362,0,0,1-.63.087,5.632,5.632,0,0,1-.726-.118m11.559,16.066.142-.021a1.71,1.71,0,0,0,0-.389,9.134,9.134,0,0,1-.29-1.111c-.048-.444-.275-.467-.625-.413-2.338.368-4.678.724-7.016,1.1a2.807,2.807,0,0,0-.634.271,3.114,3.114,0,0,0,.719.055c2.306-.356,4.608-.736,6.915-1.082.127-.019.365.178.422.325a13.169,13.169,0,0,1,.37,1.265M18.6,419.253c.236,0,.473.006.709,0a.647.647,0,0,0,.275-.071A.2.2,0,0,0,19.6,419c-.093-.052-.242-.134-.3-.1-.542.354-.848.048-1.144-.362a.373.373,0,0,0-.293-.077c-.041,0-.113.151-.1.213.158.58-.259.683-.652.814-.136.045-.268.1-.4.15a3.57,3.57,0,0,0,.407.19c.379.124.708.27.593.775a.788.788,0,0,0,.044.279c.089-.028.225-.029.26-.089.21-.36.966-.173.852-.85,0,0,.039-.012.094-.027.025.083.024.19.078.239a3.386,3.386,0,0,0,.469.352c.022.014.1-.056.15-.087-.109-.115-.3-.22-.313-.347a.86.86,0,0,0-.739-.827m-2.215,2.295c-.2-.173-.3-.252-.394-.346a.957.957,0,0,1-.116-.2c.082-.014.211-.068.239-.036.12.141.2.311.313.462a2.773,2.773,0,0,0,.352.42c.045.041.163,0,.248,0-.046-.138-.084-.28-.14-.415-.162-.387-.294-.805-.81-.867-.037,0-.065-.079-.1-.127.354,0,.684.009,1.013-.008.063,0,.127-.109.173-.18.01-.015-.055-.115-.091-.118a5.206,5.206,0,0,0-1.154-.088,12.616,12.616,0,0,0-1.6.367c-.093.024-.168.118-.251.18.091.064.179.173.275.181a2.934,2.934,0,0,0,.517-.027c.026.247.037.432.068.612a2.807,2.807,0,0,0,.108.349c.041.132.082.265.122.4a1.642,1.642,0,0,0,.268-.3c.1-.187.051-.574.443-.232.071.062.259-.007.515-.024m.391,16.178c.612-.1,1.147-.166,1.675-.271a2.939,2.939,0,0,0,.57-.242c-.236-.043-.472-.087-.709-.127-.019,0-.042.016-.064.02-.48.084-.96.162-1.438.255-.077.015-.141.1-.211.155l.176.21m2.633-.4c.289-.045.49-.069.688-.111a3.782,3.782,0,0,0,.391-.127c-.032-.077-.052-.21-.1-.22a1.694,1.694,0,0,0-.48-.023,1.469,1.469,0,0,0-.384.094,2.322,2.322,0,0,0-.3.159l.181.227m-.14-1.029c-.138-.108-.221-.207-.253-.193-.185.082-.359.191-.536.291.141.109.275.284.426.3.093.01.212-.224.364-.4m-6.516-13.842c-.128.368-.215.577-.265.795-.013.055.09.137.14.207a2.386,2.386,0,0,0,.371-.487c.034-.079-.1-.232-.246-.514m2.7-2.411c.139-.127.309-.253.3-.276a2.507,2.507,0,0,0-.305-.378c-.068.086-.2.177-.19.257a1.261,1.261,0,0,0,.2.4m38.889,10.411c-.278-.143-.417-.247-.445-.223a.937.937,0,0,0-.244.346c-.014.035.139.2.169.184a4.179,4.179,0,0,0,.52-.307M17.8,436.8l.26-.307c-.077-.061-.164-.181-.228-.17a1.429,1.429,0,0,0-.374.181l.342.3M28.57,424.627l.218-.212-.522-.591c-.036.052-.116.128-.1.151.126.222.268.435.406.651m-7.555-6.067c-.081.111-.167.178-.164.24s.1.123.149.184a.956.956,0,0,0,.162-.224c.012-.033-.072-.1-.146-.2m-3.877.518.124.072.209-.358-.119-.07-.214.355m-5.961,4.171.007.127.379-.033-.006-.094Zm16.234.023-.082.108.288.2.068-.094-.273-.211m3.7,7.132-.076.094.315.2.063-.095-.3-.2m-19.031-7.635-.077.1.2.14.062-.082-.181-.155m1.383.488c.036-.079.081-.133.068-.163s-.078-.054-.121-.08c-.019.035-.058.074-.052.1s.053.074.1.14m17.212,7.84.136-.01-.039-.239-.111.012.014.236m-9.913-12.963-.058.049.159.2.069-.058-.17-.194m-7.433,2.775-.015.061.195.049.015-.061-.194-.049m11.419,20.438a.778.778,0,0,0-.042.207.132.132,0,0,0,.074.093.112.112,0,0,0,.091-.063c.007-.029-.033-.069-.124-.236m-13.93-17.884c.033-.024.072-.038.078-.061s-.024-.052-.038-.078l-.1.057.06.082m15.824-1.695a.427.427,0,0,0-.043-.023.092.092,0,0,0-.013.022.452.452,0,0,0,.041.027l.015-.026m-12.361,1.814c-.012-.016-.021-.039-.034-.041s-.035.013-.052.02c.011.015.019.039.032.042s.035-.012.054-.021m6.707-3.6a.359.359,0,0,0-.036-.045s-.026.009-.026.014a.322.322,0,0,0,.008.057l.053-.026m4.994,2.048.014.018.008-.021Z",
    transform: "translate(0 -385.832)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M281.481,12.736c-.75.03-1.5.08-2.251.085q-2.377.014-4.755-.014c-1.143-.013-2.285-.081-3.427-.075a7.168,7.168,0,0,0-1.09.245,4.194,4.194,0,0,1-.694.007q0,.1,0,.208c2.094,0,4.188-.036,6.281.01s4.2.176,6.306.269c-.067.033-.206.056-.258.136a2.544,2.544,0,0,0-.238.536c-.011.03.1.107.086.131-.369.76.248,1.509.024,2.266-.01.032,0,.075-.014.1a3.91,3.91,0,0,0-.469,2.559.753.753,0,0,1-.1.267l-.184-.005c0-.464.03-.93-.006-1.392q-.143-1.817-.343-3.63c-.019-.169-.193-.321-.3-.48a5.139,5.139,0,0,1-.259.54.86.86,0,0,1-.289.285,5.375,5.375,0,0,1-.575.251,2.9,2.9,0,0,1,.315.488,1.814,1.814,0,0,1,.05.5c-.875-.164-1.745-.523-2.539.276.426,0,.823,0,1.219,0a.784.784,0,0,1,.349.058c.087.047.135.164.2.25a1.189,1.189,0,0,1-.244.057c-.511.011-1.023.027-1.534.011-.111,0-.21-.152-.328-.2a1.073,1.073,0,0,0-.424-.086c-.075,0-.145.113-.218.175.091.073.179.148.272.217a2.156,2.156,0,0,1,.574.547c-.318-.2-.641-.4-.954-.607q-.763-.509-1.515-1.033a1.085,1.085,0,0,0-1.5.183,3.292,3.292,0,0,1-1.827.442,3.831,3.831,0,0,0-.9-.008c-.43.006-.86.02-1.29.013-.061,0-.119-.107-.179-.165.076-.038.151-.108.227-.11.389-.011.778-.005,1.168-.005l.021-.24c-.531-.047-1.064-.08-1.594-.146a7.051,7.051,0,0,1-1.181-.231c-.1-.03-.144-.274-.179-.428-.006-.025.181-.083.267-.141.069-.047.161-.114.169-.181s-.087-.141-.155-.179c-.48-.267-.988-.491-1.443-.8-.374-.25-.6-.119-.637.227-.062.6.018,1.213-.029,1.816-.081,1.028-.206,2.053-.334,3.076-.017.136-.191.245-.239.385a6.3,6.3,0,0,0-.161.7l-.007,0a1.911,1.911,0,0,1-.219-.246c-.109-.174-.2-.359-.3-.533l.624-.5h0c.046-.255.108-.508.135-.765.044-.42-.06-.742-.641-.712.53-.039.43-.262.355-.613a13.734,13.734,0,0,1-.165-1.81c-.057-.748-.114-1.5-.165-2.246a3.506,3.506,0,0,0-.051-.889,2.37,2.37,0,0,0-.613-1.132,7.244,7.244,0,0,0-1.77-.831c-1.31-.481-1.455-1.431-.495-2.376a39.142,39.142,0,0,1,4.437-3.582,19.275,19.275,0,0,1,5.2-3.083,6.345,6.345,0,0,1,3.08-.532c.555.094,1.138.037,1.687.15.314.064.576.354.88.5A21.519,21.519,0,0,1,281.4,3.981a10.3,10.3,0,0,1,2.493,2.714,2.273,2.273,0,0,1-1.688,2.98c-.468.033-.545.164-.323.61a8.258,8.258,0,0,1,.517,1.586c.032.123-.092.288-.168.5a11.458,11.458,0,0,0-.176-1.442,1.747,1.747,0,0,0-.471-.876c-.162-.139-.523-.04-.8-.06-.113-.008-.267-.008-.328-.078-.21-.238-.369-.523-.587-.751a.433.433,0,0,0-.407-.077c-.649.479-1.3.025-1.945.019-1.493-.015-2.987-.192-4.478-.165-1.779.033-3.556.212-5.334.32-.177.011-.358-.059-.535-.051-.451.023-.97-.091-1.1.593-.017.088-.454.178-.663.128a1.061,1.061,0,0,0-1.268.835c0,.085.088.241.156.253a4.131,4.131,0,0,0,.809.067c.1,0,.2-.1.306-.153-.083-.056-.163-.117-.25-.166-.116-.065-.238-.12-.444-.222a1.783,1.783,0,0,1,.424-.252,7.079,7.079,0,0,1,1.026-.163c.549-.041,1.1-.026,1.652-.073,1.12-.095,2.237-.292,3.356-.306,1.767-.022,3.538.037,5.3.13.9.047,1.781.254,2.675.36a4.088,4.088,0,0,0,.627-.1,1.8,1.8,0,0,1,.452.082c.264.057.491.7.806.05a.185.185,0,0,1,.177-.032c.054.035.118.164.1.177a4.808,4.808,0,0,1-.493.423c-.055.041-.149.03-.225.043.059.07.117.2.178.2a1.545,1.545,0,0,0,.443-.081c.147-.04.289-.1.434-.147l.086.681-.429-.212-.045.072a4.035,4.035,0,0,1,.368.206c.1.072.272.17.27.253a1.3,1.3,0,0,1-.17.507,3.123,3.123,0,0,1-.261.383Zm-2.641-1.6.022-.008-.026,0-.24-.129-.017.034c.087.033.174.066.262.1m-5.18,3.152c.236-.123.476-.239.7-.379.028-.018-.02-.244-.043-.246a14.534,14.534,0,0,0-1.575-.079c-.122,0-.238.235-.357.361l.313.276.077.077a5.637,5.637,0,0,0,.664.347,2.136,2.136,0,0,0,.228-.364Zm-.077-3.81.008.008.947-.07-.007-.155h-3.119c.328.106.639.2.946.309s.579.234.876.328a1.319,1.319,0,0,0,.381.006h2.061l.018-.184c-.253-.028-.506-.054-.758-.083l-1.352-.158m.444,1.16-.048.072a1.22,1.22,0,0,1-.372-.112,4.007,4.007,0,0,0-2.418-.515c-.981-.016-1.964.064-2.946.1-.054,0-.109-.035-.164-.037a4.021,4.021,0,0,0-2.668.489c-.094.067-.136.207-.2.313a1.539,1.539,0,0,0,.343.158,3.616,3.616,0,0,0,.569.046c.893.029,1.785.059,2.678.078.655.014,1.311.006,1.967.019.167,0,.333.075.5.073.293,0,.585-.048.878-.056.336-.009.672,0,1.008.008a2.73,2.73,0,0,1,.364.027,6.474,6.474,0,0,0,.926.148c.779,0,1.557-.037,2.336-.05.156,0,.312.053.469.053,1.2,0,2.393,0,3.59-.014a2.545,2.545,0,0,0,.594-.155c-.053-.122-.073-.311-.164-.355a7.477,7.477,0,0,0-1.416-.589c-.292-.073-.638.11-.956.094-.82-.043-1.637-.16-2.457-.2-.871-.037-1.745-.016-2.618-.016-.048,0-.1.04-.251.11l.461.306m.477-4.676c.059-.261.173-.47.131-.641a1.345,1.345,0,0,0-.384-.72c-.125-.1-.437.048-.665.088-.156.027-.311.07-.468.085s-.432-.028-.441.008a9.3,9.3,0,0,0-.161,1.017.581.581,0,0,1,.1.019c.122.053.242.11.363.165-.139.032-.279.058-.415.1s-.262.1-.393.147c.125.086.24.22.378.248.3.061.6.057.9.1.092.014.172.107.258.164-.086.05-.171.141-.258.144-.387.012-.777-.022-1.161.011-.081.007-.144.224-.215.344.293.16.582.447.878.454a13.508,13.508,0,0,0,2.155-.176c.146-.02.283-.246.382-.4a.3.3,0,0,0-.063-.286c-.088-.063-.253-.017-.344-.078a3.026,3.026,0,0,1-.4-.379c.5-.487-.1-.369-.177-.415m1.193,3.6-.024.193,2.386.283.012-.107-2.374-.37m-8.76.192.327-.277c-.232-.081-.46-.174-.7-.236-.056-.015-.138.07-.208.11l.579.4m-.864,2.408q.007-.107.013-.214c-.333-.029-.666-.061-1-.082-.038,0-.1.06-.113.1s.038.13.066.132c.344.028.689.043,1.034.062m-.435-.637-.024.129c.25.039.5.079.75.112a.886.886,0,0,0,.029-.114c-.21-.052-.42-.107-.631-.153-.037-.008-.082.017-.124.027M281,17.039l.168.043.15-.664-.149-.035-.168.655m-10.566-1.455c.1-.085.2-.136.208-.194s-.089-.129-.14-.194a.879.879,0,0,0-.189.187c-.016.028.063.109.122.2m5.862.022c-.086-.054-.138-.112-.187-.109s-.091.068-.136.105c.047.04.09.106.142.114s.1-.055.181-.109m3.525-4.946.02-.1-.342-.08-.023.113.345.071m-15.346,2.224-.092.087.223.235.094-.088-.224-.234m7.307-2.218v-.014h-.225s0,.009,0,.014Zm-2.036,4.383a.384.384,0,0,0-.069.077c0,.009.024.048.035.047a.286.286,0,0,0,.082-.029l-.049-.095M277.785,8.9l-.022.009.018.015Zm-7.43,3.815-.025-.006.006.024Z",
    transform: "translate(-242.724 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M360.245,365.147l-.517,1.291-.136-.508a2.487,2.487,0,0,1-.1.476c-.092.182-.181.465-.325.5a2.674,2.674,0,0,0-1.415,1.155,1.743,1.743,0,0,1-.536.446,7.279,7.279,0,0,1-5.707.4c-.226-.064-.5.049-.744.036-.1-.005-.2-.123-.27-.214s-.076-.274-.1-.272c-.465.045-.585-.841-1.172-.434l.005-.005-.218,0,.007.007-.3-.681c-.153-.134-.337-.3-.523-.459a.484.484,0,0,0-.167-.114,1.366,1.366,0,0,1-.723-1.818.235.235,0,0,1,.211-.087c.221.069.433.167.648.255l-.19.07-.026.011.031-.006a4.058,4.058,0,0,0,.754.267c.148.023.318-.143.482-.152q.892-.048,1.786-.034c.088,0,.169.159.262.231s.287.236.324.209c.3-.222.439-.142.519.192.008.035.118.046.181.068l-.005-.005,1.239.17.04.081-.037-.084c.2-.2.365-.546.724-.181.027.027.212-.1.337-.165-.01-.036-.006.079.05.158a2.066,2.066,0,0,0,.42.472c.035.026.23-.161.351-.249l-.377-.2c.073-.466.4-.216.684-.169a.543.543,0,0,0,.423-.125c.289-.308.813-.25,1.268.176l.021-.009-.025,0c.265-.25.524-.507.8-.739.03-.025.272.116.265.148a8.575,8.575,0,0,1-.243.855,1.167,1.167,0,0,1-.121.212.813.813,0,0,0,.207.063,3.942,3.942,0,0,0,.569-.015.281.281,0,0,0,.206-.132c.021-.06-.045-.154-.081-.23s-.08-.138-.12-.207c.076-.037.181-.128.223-.1.651.358.8-.29,1.139-.555v0m-10.895.362c-.057.063-.13.108-.129.152s.083.136.108.129c.059-.016.106-.079.158-.122l-.137-.159m.7.182h0m1.744.216c0,.008-.012.018-.01.025s.014.012.022.017l.017-.042H351.8",
    transform: "translate(-323.593 -340.055)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M607.61,480.544a3.722,3.722,0,0,0,.527-.029,2.12,2.12,0,0,0,.4-.161c-.119-.057-.24-.164-.358-.162-.694.009-.9-.382-.862-1.023l.8.232,0,.076-.415-.039-.049.2c.189.049.377.1.567.146.217.053.437.1.648.165.013,0-.045.2-.053.3a.537.537,0,0,0,.046.171c.066-.031.186-.057.189-.094.019-.2.009-.411.009-.731.379.244.784.513,1.2.769.373.232.758.444,1.13.677a2.135,2.135,0,0,1,.3.279,3.124,3.124,0,0,0-.459.363c-.1.11-.219.305-.182.41.2.573-.039.953-.63.878-.513-.066-1.018-.192-1.526-.294-.066-.013-.155-.022-.189-.067-.634-.84-1.712-.466-2.487-.914-.036-.021-.117,0-.129-.025-.3-.616-1-.488-1.472-.786a3.237,3.237,0,0,0-.784-.222c-.172-.052-.336-.129-.563-.217a3.01,3.01,0,0,1,.945-.417c.187-.008.392.293.58.464.1.09.165.221.274.291a.342.342,0,0,0,.272-.014c.028-.012.032-.17,0-.228-.233-.37-.309-.675.238-.826.078-.021.122-.161.183-.246-.086-.059-.175-.113-.256-.179-.308-.249-.614-.5-.921-.752l.123-.119,2.367.713c-.042.056-.146.131-.138.193.09.736-.5.474-.834.574-.141.042-.286.074-.429.11a2.71,2.71,0,0,0,.391.244.659.659,0,0,0,.245.047c-.063.384-.122.725-.168,1.067,0,.019.139.091.159.074.117-.1.208-.228.327-.324.146-.117.328-.31.465-.287s.26.256.361.414c.057.089.037.227.092.319a.59.59,0,0,0,.242.2c.032.016.151-.05.157-.09a.879.879,0,0,0-.035-.272c-.034-.194-.07-.387-.124-.685l-.163-.033c0-.047,0-.094,0-.14m2.845.7a2.5,2.5,0,0,0,.356.066,1.953,1.953,0,0,0,.3-.039c-.078-.079-.155-.227-.234-.227a1.28,1.28,0,0,1-1.2-.913c-.029-.064-.163-.08-.249-.118a1.827,1.827,0,0,1-.067.255c-.054.129-.1.334-.189.363a4.255,4.255,0,0,1-.74.093,1.608,1.608,0,0,0-.246.07c.022.067.025.153.069.2.275.277.56.544.747.724l-.148.6a2.4,2.4,0,0,0,.466-.288c.114-.11.137-.319.257-.415a1.954,1.954,0,0,1,.543-.243c.018-.007.068.072.1.111a2.872,2.872,0,0,0-.385.252,2.142,2.142,0,0,0-.253.328c.337.206.672.413,1.016.605.009,0,.178-.177.163-.248-.079-.374-.193-.74-.313-1.176m-4.061-1.632.265-.193c-.079-.064-.162-.182-.237-.178s-.165.12-.246.188l.219.183m-.313-.484.019-.057-.4-.1-.01.064.39.095m-.256,1.475a.374.374,0,0,0-.023.1c0,.013.04.036.044.033.021-.017.05-.042.049-.062s-.036-.037-.071-.069m2.718,1.229.031-.023-.118-.171-.04.03.127.164m-1.417-.349-.05-.024-.019.045c.009,0,.02.011.026.009a.269.269,0,0,0,.043-.03",
    transform: "translate(-562.258 -445.897)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M399.932,310.34l-.443.2a1.776,1.776,0,0,1,.358.1,1.337,1.337,0,0,1,.206.188c-.069.064-.136.181-.207.183a3.083,3.083,0,0,1-1.073-.027,12.944,12.944,0,0,0-4.592-.258c-.529.008-1.058.1-1.586.1-.166,0-.477-.226-.466-.316a1.039,1.039,0,0,1,.4-.6c.1.422.849.65,1.281.465a6.5,6.5,0,0,1,1.556-.512c.27-.04.584.22.879.344.059.025.15.088.172.069.786-.653,1.434.025,2.133.209.248.065.5.1.758.141l-.636-.755,1.245.492Zm-4.409,0,.019-.07-.246-.037-.011.07.238.037",
    transform: "translate(-365.473 -288.783)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M420.74,269.582l.564-.244-.029-.185a4.552,4.552,0,0,0-1.085.155c-.4.159-.692.439-1.061-.127-.126-.193-.7-.092-1.072-.126l.3.565a4.072,4.072,0,0,1-1.142-.457c-.185-.158-.175-.544-.172-.877.245.455.5.641.944.29.051-.041.161,0,.231-.028.44-.18.807.2,1.339.069a5.221,5.221,0,0,1,2.186.407c.052.012.122.215.1.233a2.765,2.765,0,0,1-.6.433c-.1.046-.267-.052-.5-.108",
    transform: "translate(-388.693 -250.049)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M574.343,453.881c.248.13.5.25.742.393.405.24.79.517,1.209.73a2.693,2.693,0,0,0,.648.1c.3.062.588.218.334.544-.121.156-.457.165-.7.2a2.174,2.174,0,0,1-.5-.043,3.175,3.175,0,0,1,.317.448c.127.264.7.465.152.838a.341.341,0,0,1-.329-.055c-.477-.8-.929-1.612-1.4-2.417-.146-.252-.315-.49-.473-.734Zm2.589,1.657c-.056-.1-.07-.167-.1-.172-.343-.073-.687-.14-1.033-.2-.022,0-.092.091-.082.115.029.066.083.162.136.168.338.04.679.058,1.075.088",
    transform: "translate(-535.301 -423.027)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M433.428,334.686a3.454,3.454,0,0,1-2.877.487c-.268-.052-.573.114-.854.091-.149-.012-.282-.214-.422-.331.13.008.26.018.39.023.056,0,.134.02.165-.009.677-.635,1.359-.111,2.044-.028a3.228,3.228,0,0,0,.825-.082c.2-.029.39-.08.73-.152",
    transform: "translate(-400.093 -311.89)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M452.54,134.391l-6.483-.7a1.361,1.361,0,0,1,.388-.133,26.858,26.858,0,0,1,6.095.828",
    transform: "translate(-415.735 -124.484)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M357.936,133.775l5.87-.5.016.2-5.86.515-.026-.209",
    transform: "translate(-333.604 -124.213)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M557.82,496.2l.614.209v-.008h.081v.008c.654.034.828.286.726.958-.022.147.136.313.179.479a1.459,1.459,0,0,1,0,.368c-.109-.064-.282-.105-.316-.2-.123-.334-.2-.685-.292-1.031a.507.507,0,0,1,.01-.127,10.739,10.739,0,0,0-1.081-.167c-.114-.008-.239.12-.358.186.06-.162.115-.326.183-.483.013-.03.079-.036.121-.053v-.008h.081v.008l.063-.15Z",
    transform: "translate(-519.493 -462.465)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M438.681,459.809c.044-.009.113-.042.129-.024.557.591.946.16,1.367-.2.095-.081.279-.069.424-.077a.581.581,0,0,1,.2.071c-.044.069-.073.174-.135.2-.276.119-.67.114-.544.6-.311.072-.669.271-.918.178-.234-.087-.353-.484-.522-.744Z",
    transform: "translate(-408.86 -428.269)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M299.118,256.642v-2.689l.709.5a2.567,2.567,0,0,0-.367.663c-.083.5-.1,1.017-.148,1.527h-.194",
    transform: "translate(-278.785 -236.69)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M318.384,287.995c.7-.072.2-.742.51-1.123a2.009,2.009,0,0,1,.22.491c.048.348.044.7.076,1.053.006.067.081.13.13.189.079.1.164.187.247.28a1.31,1.31,0,0,1-.433.123c-.066,0-.112-.195-.183-.289-.19-.253-.389-.5-.566-.725",
    transform: "translate(-296.741 -267.371)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M376.118,331.475l-.685-1.581.238-.108,1.24,1.925-.791-.238Z",
    transform: "translate(-349.912 -307.368)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M503.642,292.881c-.079-.075-.165-.145-.236-.227s-.132-.182-.2-.273c.137.016.311-.016.4.057a9.178,9.178,0,0,1,1.115.96c.123.131.1.406.123.617,0,.027-.166.1-.169.1-.091-.138-.156-.294-.256-.423a5.271,5.271,0,0,0-.375-.377c-.137-.142-.268-.29-.4-.435Z",
    transform: "translate(-469.002 -272.505)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M334.018,278.818a1.429,1.429,0,0,1,.344.282,2.949,2.949,0,0,1,.28.616,4.7,4.7,0,0,1,.3,1.26c-.251-.49-.5-.984-.758-1.468-.069-.127-.214-.212-.283-.338a1.582,1.582,0,0,1-.1-.393l.224.037-.005.005",
    transform: "translate(-311.108 -259.826)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M568.17,266.782c-.062-.459-.147-.917-.177-1.378a2.671,2.671,0,0,1,.1-.795c.018-.074.182-.112.278-.166a2.282,2.282,0,0,1,.052.388c-.018.556-.046,1.111-.075,1.667a2.531,2.531,0,0,1-.043.276l-.136.008",
    transform: "translate(-529.379 -246.467)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M568.934,463.095l.225.279-.562.154a1.922,1.922,0,0,0-.029-.323q-.118-.455-.259-.9c-.04-.128-.112-.247-.153-.375-.005-.016.127-.1.141-.092a1.08,1.08,0,0,1,.291.291c.162.3.3.622.442.934l-.1.036",
    transform: "translate(-529.534 -430.439)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M485.7,507.433c.186.152.427.276.534.471.045.082-.206.313-.3.487a4.747,4.747,0,0,1-.319.58c.106-.453.028-.683-.5-.552.135-.1.266-.2.406-.292.1-.067.22-.116.33-.172l-.217-.391.071-.132",
    transform: "translate(-452.132 -472.939)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M543.963,333.522c-.152.227-.319.446-.451.684-.17.309-.312.634-.466.952a6.184,6.184,0,0,0,.159-.786,6.3,6.3,0,0,0-.052-.679c0-.045.084-.13.132-.132.241-.01.554.159.6-.28,0-.018.1-.049.109-.041.074.113.14.232.208.349l-.235-.067",
    transform: "translate(-506.132 -310.585)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M574.464,529.714c-.369-.088-.741-.165-1.1-.274-.093-.028-.155-.158-.232-.241.095-.048.208-.156.281-.133.389.12.767.273,1.149.414l-.095.233",
    transform: "translate(-534.169 -493.099)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M317.561,323.726c.122-.114.234-.307.368-.323.237-.029.641-.028.7.1a3.166,3.166,0,0,1,.278,1.276c-.121-.332-.222-.673-.372-.991a.677.677,0,0,0-.365-.336c-.072-.022-.206.2-.328.287a.971.971,0,0,1-.269.093l-.017-.1",
    transform: "translate(-295.974 -301.404)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M600.641,512.012c.142.355.244.6.339.853a3.858,3.858,0,0,1,.124.382c.033.125.054.253.08.379-.124-.08-.32-.135-.36-.246a8.9,8.9,0,0,1-.285-1.082c-.012-.052.04-.119.1-.287",
    transform: "translate(-559.714 -477.207)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M512.3,340.04a7.56,7.56,0,0,1,.1-.865c.022-.1.169-.183.273-.253.035-.023.114.02.172.032a2.768,2.768,0,0,0-.128.326c-.048.185-.069.376-.12.559a2.905,2.905,0,0,1-.154.364l-.142-.164",
    transform: "translate(-477.474 -315.877)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M459.046,329.41h-1.457v-.134h1.457Z",
    transform: "translate(-426.483 -306.893)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M455.145,447.873c.3-.112.6-.229.9-.329.021-.007.131.139.118.16-.063.1-.146.235-.239.249a4.65,4.65,0,0,1-.7.012l-.075-.092",
    transform: "translate(-424.205 -417.121)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M386.1,363.408h-1.315l.013-.281,1.3.165q0,.058,0,.116",
    transform: "translate(-358.626 -338.442)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M136.805,540.247l-.581.949a2.4,2.4,0,0,1,.018-.724c.053-.156.269-.256.413-.381l.15.157",
    transform: "translate(-126.946 -503.376)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M555.31,187.358l.626.106-.046.2h-1.651l1.081-.309-.009.008",
    transform: "translate(-516.562 -174.614)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M615.21,494.963l-1.139-.086.013-.179h1.126Z",
    transform: "translate(-572.328 -461.07)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M306.282,307.251c.285.091.565.175.842.272.053.018.133.1.125.123a.342.342,0,0,1-.141.2c-.282.113-.839-.345-.826-.6",
    transform: "translate(-285.461 -286.365)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M553.282,454.015a3.094,3.094,0,0,1-.559-.347c-.084-.08-.075-.257-.108-.391a1.281,1.281,0,0,0,.252.223,3.913,3.913,0,0,0,.439.149c.1.035.194.082.291.123l-.315.243",
    transform: "translate(-515.05 -422.464)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M426.218,329.06h1.374l0,.085h-1.4l.033-.085",
    transform: "translate(-397.214 -306.691)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M426.148,504.416l-.505-.2a1.513,1.513,0,0,1,.459-.184c.115-.006.237.118.356.184l-.31.2",
    transform: "translate(-396.709 -469.773)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M553.526,311.108l-.088.973-.245-.028.163-.976.17.032",
    transform: "translate(-515.588 -289.93)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M542.865,285.406l.232-.878.231.067-.267.865-.2-.053",
    transform: "translate(-505.962 -265.186)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M552.663,463.825a6.547,6.547,0,0,1-.585-.352c-.033-.024.023-.169.037-.258l.671.384-.124.226",
    transform: "translate(-514.54 -431.727)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M474.228,258.485c-.249-.092-.5-.176-.743-.283-.052-.023-.068-.126-.1-.192.067-.025.156-.091.2-.069.244.133.476.287.713.433l-.067.111",
    transform: "translate(-441.205 -240.402)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M362.68,295.434l-.243-.488,0-.01c.122.13.247.259.367.392a2.623,2.623,0,0,1,.19.242.442.442,0,0,1-.091.074c-.079-.067-.15-.142-.224-.215l.006.005",
    transform: "translate(-337.796 -274.887)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M521.687,351.479l-.374.268.289-.742c.069.083.169.158.2.253.017.06-.075.151-.118.229l.008-.008",
    transform: "translate(-485.875 -327.145)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M408.346,453.712l.872.126-.1.314-.773-.445v0",
    transform: "translate(-380.587 -422.866)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M447.111,299.04l-.783.113-.035-.2.765-.117.052.206",
    transform: "translate(-415.955 -278.52)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M419.829,255.44c.13-.193.256-.389.4-.574.016-.021.138,0,.168.036s.07.169.045.191c-.172.152-.36.285-.542.425l-.067-.079",
    transform: "translate(-391.29 -237.533)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M558.895,475.769l-.589.186-.03-.467.62.281",
    transform: "translate(-520.325 -443.165)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M440.379,501.953c.048.134.171.307.126.392-.067.127-.252.191-.471.338l.158-.549.187-.181",
    transform: "translate(-410.121 -467.831)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M154.805,564.533c-.108-.2-.179-.278-.163-.314.087-.193.2-.375.3-.561.037.059.117.128.105.174-.05.193-.127.38-.241.7",
    transform: "translate(-144.128 -525.342)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M716.789,548.068c.247.107.495.213.738.327.013.006,0,.121-.022.133a.273.273,0,0,1-.2.033c-.193-.1-.374-.223-.56-.337l.045-.157",
    transform: "translate(-668.021 -510.812)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M709.935,506.038l-1.256-.575.068-.14,1.239.611-.05.1",
    transform: "translate(-660.505 -470.972)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M141.983,531.63l.033.48-.346-.3.313-.178",
    transform: "translate(-132.04 -495.491)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M138.15,554.985l-.454.512-.146-.126.451-.513.149.127",
    transform: "translate(-128.2 -517.14)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M421.694,372.684l-.654.227-.052-.391.706.164",
    transform: "translate(-392.37 -347.197)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M378.254,413.143l-.456-.278.267-.155.18.438Z",
    transform: "translate(-352.116 -384.655)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M376.29,302.391l.409-.6c.207.35.019.534-.4.595Z",
    transform: "translate(-350.711 -281.276)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M454.1,505.357l-.222-.2c.093-.048.186-.131.28-.133.063,0,.129.113.193.175l-.251.155",
    transform: "translate(-423.025 -470.696)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M464.87,299.523l.539.416-.09.129-.561-.387.111-.158",
    transform: "translate(-433.166 -279.162)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M385.372,247.3h.743l0,.088h-.769l.029-.088",
    transform: "translate(-359.148 -230.485)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M531.379,401.684l.184,1.116-.078.02-.231-1.117.126-.019",
    transform: "translate(-495.14 -374.379)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M428.213,459.362l-.768-.1.049-.234.713.337h.005",
    transform: "translate(-398.388 -427.823)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M410.021,463.989c-.112-.084-.227-.164-.331-.257-.013-.012.033-.09.052-.138l.38.26-.1.135",
    transform: "translate(-381.838 -432.08)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M359.495,349.474l.2-.532.17.068-.246.508-.123-.043",
    transform: "translate(-335.057 -325.222)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M433.4,528.313l.867.1,0-.006c-.3.058-.618.308-.861-.1Z",
    transform: "translate(-403.942 -492.397)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M560.214,447.732l-.868-.147.053-.22.81.376,0-.009",
    transform: "translate(-521.323 -416.954)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M409.613,440.272a2.6,2.6,0,0,1,.174.419c.006.03-.132.131-.15.119-.072-.048-.16-.123-.169-.2s.065-.164.146-.342",
    transform: "translate(-381.632 -410.343)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M528.672,364.132l-.091.366c-.053-.031-.155-.068-.152-.092a2.074,2.074,0,0,1,.092-.325l.151.051",
    transform: "translate(-492.508 -339.332)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M594.174,500.97l.341.525-.242.091-.093-.623Z",
    transform: "translate(-553.783 -466.909)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M557.944,492.549l-.437-.1.166-.163.263.274.008-.008",
    transform: "translate(-519.609 -458.819)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M562.638,518.219a2.218,2.218,0,0,1,.2.328c.008.021-.132.131-.14.124a1.177,1.177,0,0,1-.227-.248c-.011-.016.074-.1.163-.2",
    transform: "translate(-524.239 -482.992)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M148.863,563.7l.2-.5.135.046-.172.505-.165-.053",
    transform: "translate(-138.744 -524.916)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M430.626,451.387l.331-.07q0,.105-.008.21l-.322-.143Z",
    transform: "translate(-401.353 -420.638)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M537.956,340.808a1.1,1.1,0,0,1,.143.248c.009.038-.053.095-.083.143a1.184,1.184,0,0,1-.181-.2c-.013-.023.058-.094.121-.187",
    transform: "translate(-501.273 -317.641)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M520.961,190.653h-.719q0-.045,0-.09h.717c0,.03,0,.06,0,.09",
    transform: "translate(-484.877 -177.609)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M394.928,435.161l-.409.022c.013-.06.019-.168.04-.171a2.684,2.684,0,0,1,.365-.008q0,.079,0,.157",
    transform: "translate(-367.701 -405.431)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M533.513,350.212l-.127-.353.21.024-.089.322.006.007",
    transform: "translate(-497.128 -326.076)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M570.736,490.851c-.126.057-.194.115-.247.1-.071-.016-.13-.086-.194-.132.059-.047.119-.132.177-.131s.136.077.263.159",
    transform: "translate(-531.529 -457.336)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M587.85,492.718q0-.2,0-.395l.209.054-.142.344.01.006h-.079Z",
    transform: "translate(-547.883 -458.856)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M544.1,191.592h-.624l0-.1h.632l-.006.1",
    transform: "translate(-506.526 -178.478)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M307.677,297.731c.126-.078.2-.154.232-.138a1.006,1.006,0,0,1,.206.185c-.046.037-.1.11-.136.1a1.455,1.455,0,0,1-.3-.149",
    transform: "translate(-286.762 -277.361)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M424.022,449.183a.622.622,0,0,1-.222.047.687.687,0,0,1-.258-.119.31.31,0,0,1,.05-.155.7.7,0,0,1,.264.067.783.783,0,0,1,.165.163v0",
    transform: "translate(-394.748 -418.437)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M433.767,373.723a1.867,1.867,0,0,1,.117-.26.9.9,0,0,1,.168.064l-.165.263-.12-.068",
    transform: "translate(-404.281 -348.075)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M383.636,419.092l.336.13q0,.06-.007.12l-.383-.017c.02-.079.041-.158.062-.237l-.008,0",
    transform: "translate(-357.507 -390.599)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M351.271,236.9c-.041-.094-.088-.15-.082-.2s.065-.087.1-.131c.035.048.1.1.1.144s-.058.1-.116.187",
    transform: "translate(-327.316 -220.484)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M434.046,297.524c.064.1.146.185.13.22a.39.39,0,0,1-.186.147c-.013.006-.109-.091-.1-.118a1.223,1.223,0,0,1,.156-.248",
    transform: "translate(-404.395 -277.299)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M433.316,254.611c.065.078.15.137.143.18s-.1.136-.147.129c-.065-.01-.12-.089-.179-.138l.183-.17",
    transform: "translate(-403.69 -237.303)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M560.913,292.441l.047-.34c.055.027.157.054.156.079a1.4,1.4,0,0,1-.059.288l-.145-.027",
    transform: "translate(-522.783 -272.245)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M473.732,446.286l.281-.042.023.11-.274.074-.03-.142",
    transform: "translate(-441.529 -415.909)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M469.579,495.86l-.343.06-.026-.091.345-.086.024.117",
    transform: "translate(-437.314 -462.044)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M539.888,138.428l-.527-.171.029-.1.548.144-.051.124",
    transform: "translate(-502.697 -128.769)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M377.409,243.492a1.044,1.044,0,0,1,.145.179c.007.014-.072.1-.1.095a.724.724,0,0,1-.182-.1l.135-.174",
    transform: "translate(-351.628 -226.94)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M358.127,312.825c-.076-.09-.14-.137-.155-.2-.008-.029.077-.118.114-.115a.191.191,0,0,1,.13.116c.012.038-.041.1-.088.195",
    transform: "translate(-333.637 -291.27)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M546.689,267.836l-.134-.155a1.181,1.181,0,0,1,.188-.142c.012-.006.11.095.1.119a.751.751,0,0,1-.154.179",
    transform: "translate(-509.401 -249.351)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M421.068,469.236l.123.132c-.029.026-.069.078-.083.071a.277.277,0,0,1-.112-.1c-.007-.011.039-.058.073-.106",
    transform: "translate(-392.376 -437.338)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M386.261,293.13c-.03.074-.058.148-.094.219a.234.234,0,0,1-.083-.019c.01-.081.026-.162.041-.243l.135.042",
    transform: "translate(-359.839 -273.165)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M308.6,292.755c-.05-.07-.1-.115-.11-.166,0-.03.079-.106.095-.1a.26.26,0,0,1,.128.12c.009.022-.058.078-.113.146",
    transform: "translate(-287.522 -272.607)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M465.051,268.858l-.263-.044c0-.024,0-.049,0-.073h.274l-.014.117",
    transform: "translate(-433.193 -250.473)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M572.59,516.873l.067.267c-.039.007-.108.029-.112.02a2.638,2.638,0,0,1-.092-.247l.136-.039",
    transform: "translate(-533.54 -481.737)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M346.289,224.582l.155-.137.081.066-.2.259c-.013-.061-.025-.122-.037-.183l.021-.01Z",
    transform: "translate(-322.749 -209.188)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M594.282,518.784a1.463,1.463,0,0,1,.25.089c.019.01,0,.095-.006.145l-.288-.116.044-.118",
    transform: "translate(-553.843 -483.518)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M347.993,347.885l-.166-.32.162-.043v.37Z",
    transform: "translate(-324.182 -323.898)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M477.018,475.1c.09.138.14.184.146.235,0,.026-.088.094-.111.085a.209.209,0,0,1-.111-.126c-.009-.043.036-.1.077-.194",
    transform: "translate(-444.519 -442.799)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M393.989,448.3c-.08.028-.128.062-.161.051a.175.175,0,0,1-.095-.1c-.007-.022.041-.062.064-.095l.192.145",
    transform: "translate(-366.967 -417.691)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M446.966,484.813c-.063.037-.1.077-.127.07s-.063-.055-.094-.085c.034-.022.067-.059.1-.061s.06.037.119.076",
    transform: "translate(-416.375 -451.785)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M566.2,528.142l-.24.158-.035-.153h.28Z",
    transform: "translate(-527.457 -492.24)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M375.364,302.7c.033.068.061.1.06.131s-.042.076-.052.072c-.035-.011-.089-.038-.091-.064s.037-.068.082-.14",
    transform: "translate(-349.771 -282.119)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M391.925,290.369a.368.368,0,0,1-.063-.109c0-.018.038-.041.059-.062a.377.377,0,0,1,.076.084c.005.011-.035.044-.073.087",
    transform: "translate(-365.224 -270.471)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M567.721,473.893a.871.871,0,0,1-.151.117c-.011,0-.074-.057-.07-.079a.138.138,0,0,1,.08-.09c.028-.009.069.024.141.053",
    transform: "translate(-528.923 -441.628)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M535.126,190.2l.294.083-.028.116-.3-.062.03-.137",
    transform: "translate(-498.721 -177.267)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M568.568,303.279l.151-.474.086.035-.23.434Z",
    transform: "translate(-529.918 -282.221)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M427.426,470.517c-.074.039-.109.073-.139.07s-.048-.048-.071-.075c.024-.02.048-.054.072-.055s.065.026.139.06",
    transform: "translate(-398.174 -438.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M416.055,502.1l.218-.058.024.064-.207.1-.034-.1",
    transform: "translate(-387.773 -467.915)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M506.229,365.21l-.153-.013c0-.021.007-.058.014-.059a1.4,1.4,0,0,1,.147,0l-.008.074",
    transform: "translate(-471.674 -340.314)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M401.278,450.033a.386.386,0,0,1-.022-.129c0-.021.047-.033.072-.048a.39.39,0,0,1,.041.109c0,.015-.042.033-.091.068",
    transform: "translate(-373.979 -419.276)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M399.51,461.957l-.077-.11.064-.042.06.124-.047.028",
    transform: "translate(-372.28 -430.413)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M432.82,471.145a.525.525,0,0,1-.046-.119c0-.009.062-.042.071-.035a.21.21,0,0,1,.06.093c0,.008-.043.031-.084.061",
    transform: "translate(-403.355 -438.974)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M526.706,357.987l.268.095-.039.065-.221-.168-.008.008",
    transform: "translate(-490.902 -333.644)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M315.686,272.61h-.293l.01-.092.283.092h0",
    transform: "translate(-293.953 -253.993)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M374.167,325.184c-.055.049-.085.1-.111.093s-.065-.043-.082-.076c-.006-.012.031-.068.05-.068a.514.514,0,0,1,.143.051",
    transform: "translate(-348.552 -303.031)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M594.842,511.216l-.213.067-.031-.079.215-.1.028.108",
    transform: "translate(-554.179 -476.364)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M461.615,500.551a.326.326,0,0,1,.083-.029c.009,0,.021.031.032.047a.348.348,0,0,1-.073.041c-.006,0-.023-.031-.042-.059",
    transform: "translate(-430.236 -466.498)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M356.089,340.437c-.016.01-.035.028-.048.025s-.026-.026-.039-.041l.065-.038.023.054",
    transform: "translate(-331.802 -317.245)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M371.4,365.417c.033.056.067.089.061.108a.172.172,0,0,1-.076.081c-.009.005-.065-.038-.062-.051a.613.613,0,0,1,.078-.138",
    transform: "translate(-346.081 -340.577)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M344.409,369.3l-.02.167h-.051l-.014-.174.085.008",
    transform: "translate(-320.918 -344.191)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M301.625,247.137l-.225-.011c0-.021,0-.041,0-.062l.217-.011.008.083",
    transform: "translate(-280.911 -230.26)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M144.553,566.742l-.016.209-.063,0v-.208h.079",
    transform: "translate(-134.653 -528.216)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M552.877,276.832c-.034.024-.059.057-.079.053s-.042-.038-.063-.059c.02-.02.041-.056.061-.055s.046.033.081.061",
    transform: "translate(-515.161 -257.957)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M421.631,2.707l-.162.171-.035-.04.206-.136Z",
    transform: "translate(-392.786 -2.518)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M542.326,231.049l.045.039a.114.114,0,0,1-.03.022.027.027,0,0,1-.022-.015.193.193,0,0,1,.007-.046",
    transform: "translate(-505.453 -215.343)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M371.179,243.877l0-.012v.006l0,.006",
    transform: "translate(-345.935 -227.248)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M338.072,271.59l-.024.053-.062-.043c.013-.014.025-.036.04-.038s.03.017.046.028",
    transform: "translate(-315.01 -253.102)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M537.873,301.715a.287.287,0,0,1-.046.027s-.022-.013-.021-.016a.312.312,0,0,1,.023-.044l.043.033",
    transform: "translate(-501.248 -281.174)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M404.7,311.807l-.032.062a.327.327,0,0,1-.064-.046s.019-.047.025-.046a.327.327,0,0,1,.072.031",
    transform: "translate(-377.1 -290.583)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M369.334,353.381l-.055.012a.3.3,0,0,1,0-.053s.024-.01.026-.007a.342.342,0,0,1,.029.048",
    transform: "translate(-344.175 -329.314)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M355.871,405.061h-.029l.018-.041c.008.006.02.01.022.017s-.007.017-.011.026",
    transform: "translate(-331.653 -377.486)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M340.6,227.065a.336.336,0,0,1-.083.019c-.008,0-.025-.047-.022-.05a.458.458,0,0,1,.076-.039l.029.069",
    transform: "translate(-317.344 -211.565)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M388.929,427.963l-.184-.119a.634.634,0,0,1,.134-.022c.01,0,.02.052.05.141",
    transform: "translate(-362.319 -398.74)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M342.785,393.648l-.026.184-.063-.01.033-.183.056.009",
    transform: "translate(-319.4 -366.88)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M411.053,476.987l-.051-.031.053-.061c.014.016.038.031.038.047s-.025.03-.04.045",
    transform: "translate(-383.063 -444.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M595.138,526.987l-.056.018-.023-.073c.019,0,.043-.005.057,0s.015.033.023.052",
    transform: "translate(-554.608 -491.111)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M431.24,530.278a.3.3,0,0,1-.045.033s-.023-.012-.023-.017a.287.287,0,0,1,.014-.053l.054.037",
    transform: "translate(-401.862 -494.197)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M547.072,332.675a.461.461,0,0,1-.06.063s-.042-.027-.041-.03a.493.493,0,0,1,.045-.071l.055.038",
    transform: "translate(-509.789 -310.025)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M348.139,217.829c-.016-.046-.04-.079-.032-.1s.047-.031.074-.037c.006,0,.034.039.029.05a.443.443,0,0,1-.071.085",
    transform: "translate(-324.442 -202.895)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M339.891,349.283l.159.21-.072.035-.082-.249Z",
    transform: "translate(-316.786 -325.536)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M540.589,314.02c0,.019,0,.037,0,.055a.147.147,0,0,1-.03,0,.445.445,0,0,1,0-.055h.032",
    transform: "translate(-503.811 -292.673)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M300.433,300.941l.006,0c.069.09.032.042,0-.006Z",
    transform: "translate(-280.01 -280.481)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M498.884,351.99a.338.338,0,0,1,.045.073c0,.008-.026.026-.041.039a.443.443,0,0,1-.054-.063s.026-.026.05-.048",
    transform: "translate(-464.925 -328.063)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M440.926,266.686c-.012.015-.024.039-.038.04s-.034-.018-.051-.028l.049-.057.04.045",
    transform: "translate(-410.87 -248.515)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M373.11,235.738l.067.072a.264.264,0,0,1-.071.038c-.012,0-.044-.026-.042-.034a.343.343,0,0,1,.046-.076",
    transform: "translate(-347.704 -219.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M583.723,489.732c.014.016.035.03.035.044s-.023.025-.036.038c-.013-.013-.035-.027-.035-.041s.022-.027.036-.041",
    transform: "translate(-544.009 -456.441)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M403.119,246.661c-.017-.008-.044-.016-.046-.026s.015-.035.023-.052l.065.034-.043.045",
    transform: "translate(-375.673 -229.82)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M410.8,246.093a.436.436,0,0,1-.086.012c-.006,0-.018-.046-.015-.048a.26.26,0,0,1,.078-.026.357.357,0,0,1,.022.062",
    transform: "translate(-382.779 -229.306)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M119.47,552.34l-.012.009.018,0-.006-.006",
    transform: "translate(-111.303 -514.793)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M352.086,330.024l-.02-.009.017-.013Z",
    transform: "translate(-328.134 -307.57)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M484.665,455.431l.011-.019.011.019Z",
    transform: "translate(-451.719 -424.454)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M424.358,337.845c.01,0,.022,0,.028,0s.006.018.009.027l-.047,0,.01-.027",
    transform: "translate(-395.503 -314.879)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M587.912,498.134l.071.132-.063.029-.071-.164-.007.008h.079Z",
    transform: "translate(-547.883 -464.269)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M523.581,372.3l.047.043-.057.047c-.012-.017-.032-.035-.032-.052s.026-.026.042-.038",
    transform: "translate(-487.95 -346.995)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M506.784,317.135l.1.073-.021.021-.069-.1-.009.008",
    transform: "translate(-472.334 -295.569)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M548.55,312.7l.013-.025c.008,0,.021.008.023.015s-.007.016-.011.024l-.025-.014",
    transform: "translate(-511.261 -291.425)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M502.562,504.977c.008.017.024.037.02.051s-.029.017-.045.026c-.008-.017-.025-.036-.021-.049s.029-.019.046-.027",
    transform: "translate(-468.355 -470.65)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M483.762,426.545l-.04-.044.064-.037c.009.017.028.036.024.049s-.029.021-.048.032",
    transform: "translate(-450.84 -397.474)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M310.1,454.677l-.007.019.015-.024Z",
    transform: "translate(-289.006 -423.764)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M434.495,540.935c.026.016.052.031,0,0l0,0Z",
    transform: "translate(-404.959 -504.164)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M558.641,517.978c.008,0,.017-.01.025-.008s.011.013.016.019l-.039.014v-.026",
    transform: "translate(-520.666 -482.759)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M399.835,284.106l.019.017-.023.008Z",
    transform: "translate(-372.651 -264.793)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M488.533,189.354h.145a.528.528,0,0,1-.071.065s-.03-.026-.074-.065",
    transform: "translate(-455.324 -176.482)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M353.8,224.042h-.026l.011-.04c.008,0,.019.008.022.014s0,.016-.008.025",
    transform: "translate(-329.724 -208.776)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M599.88,527.808l-.011-.027c.009,0,.02-.012.026-.009s.008.017.012.026l-.027.01",
    transform: "translate(-559.091 -491.895)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M599.46,532.27c-.009,0-.021.011-.026.008s-.008-.017-.011-.026.021-.011.027-.008.008.017.011.026",
    transform: "translate(-558.675 -496.063)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M599.6,540.133l.013.033-.027.01.014-.043",
    transform: "translate(-558.831 -503.416)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M380.179,294.476a.076.076,0,0,1,.012.022c0,.005-.006.012-.009.018l0-.047Z",
    transform: "translate(-354.335 -274.452)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M565.38,514.808c.007-.015.008-.028.015-.031s.017.006.026.01l-.041.022",
    transform: "translate(-526.947 -479.783)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M512.084,335.932l.016.015-.019.006Z",
    transform: "translate(-477.27 -313.096)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M593.586,500.878l-.049.005c.006,0,.013-.012.017-.011a.126.126,0,0,1,.025.014l.006-.008",
    transform: "translate(-553.19 -466.824)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M376.305,310.542l.023.039c0-.007,0-.016,0-.021a.082.082,0,0,0-.023-.013s0-.005,0-.005",
    transform: "translate(-350.721 -289.432)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M568.586,309.706l.018.053c0-.009,0-.019,0-.026a.1.1,0,0,0-.025-.022s.007-.005.007-.005",
    transform: "translate(-529.929 -288.653)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M300.44,300.548c0-.025.005-.05,0,0,.012-.049.006-.025,0,0,0,0,0,0,0,0",
    transform: "translate(-280.016 -280.091)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M572.209,452.846l-.152-.075,0,.009.156.067h0",
    transform: "translate(-533.167 -421.992)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M431.254,294.344l.013-.025.012.025Z",
    transform: "translate(-401.938 -274.312)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M562.791,529.141l-.013.022.018-.017Z",
    transform: "translate(-524.522 -493.171)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M297.3,261.776c.008,0,.022.007.021.011a.087.087,0,0,1-.011.027c-.007,0-.02-.007-.02-.011a.077.077,0,0,1,.009-.027",
    transform: "translate(-277.086 -243.981)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M553.289,482.2h.02l-.01.018Z",
    transform: "translate(-515.677 -449.424)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M362.86,234.15l.026.006-.021-.011Z",
    transform: "translate(-338.194 -218.228)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M349.973,354.592l-.015.027.02-.019,0-.007",
    transform: "translate(-326.169 -330.488)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M441.394,486.179l0-.032-.008.022,0,.01",
    transform: "translate(-411.385 -453.1)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M339.36,348.205l-.045-.065.028-.013.011.082.005,0",
    transform: "translate(-316.249 -324.462)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M421.994,381.177l-.006,0,.006,0",
    transform: "translate(-393.303 -355.261)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M408.345,453.571l.015-.01-.013.014s0,0,0,0",
    transform: "translate(-380.587 -422.729)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M310.373,454.672l.005.022-.013-.016.008-.006",
    transform: "translate(-289.267 -423.764)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M539.315,368.384l-.156.05v0l.149-.046h.008",
    transform: "translate(-502.507 -343.342)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M541.354,368.22l.016-.013-.008.012h-.007",
    transform: "translate(-504.554 -343.177)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M533.635,356.569l.007.007Z",
    transform: "translate(-497.36 -332.33)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M385.5,356.865l.011-.008-.013.007h0",
    transform: "translate(-359.295 -332.599)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M378.664,292.994l-.007.006.007-.006",
    transform: "translate(-352.917 -273.077)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M569.97,528.152l-.006-.005.006.005",
    transform: "translate(-531.22 -492.245)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M446,529.53l-.011-.025.014.018s0,.007,0,.007",
    transform: "translate(-415.675 -493.511)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M562.971,529.151l-.006-.005.006.005",
    transform: "translate(-524.697 -493.176)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M362.254,294.957l-.018-.009h.013a.061.061,0,0,1,0,.009",
    transform: "translate(-337.612 -274.898)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M521.138,292.934l.006,0Z",
    transform: "translate(-485.712 -273.019)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M467.484,506.023l-.005.013.009-.007Z",
    transform: "translate(-435.7 -471.624)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M733.128,517.673H733.1l.019,0,0,0",
    transform: "translate(-683.27 -482.479)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M467.283,506.036l-.024,0,.02-.01s0,.005,0,.005",
    transform: "translate(-435.496 -471.632)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M378.767,293.1l-.1-.1-.007.006.1.1.007-.006",
    transform: "translate(-352.917 -273.081)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M434.276,540.945l-.021.012.016-.015s.005,0,.005,0",
    transform: "translate(-404.735 -504.17)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M509.59,299.674l0,.024s-.011-.018-.012-.018l.008-.005",
    transform: "translate(-474.942 -279.303)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M318.09,292.644l-.011.018s0-.021,0-.022l.008,0",
    transform: "translate(-296.457 -272.748)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M572.837,499.293h.078v-.008h-.081Z",
    transform: "translate(-533.896 -465.345)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M371.291,244.441l.022-.008-.017.013s0-.005,0-.005",
    transform: "translate(-346.052 -227.817)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M140.438,528.8l0-.006,0,.006",
    transform: "translate(-130.891 -492.846)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M362.866,234.145l0,.006,0-.006",
    transform: "translate(-338.195 -218.228)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M561.839,498.293h.078v-.008h-.081Z",
    transform: "translate(-523.646 -464.413)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M352.087,338.557l-.013,0,.014,0h0",
    transform: "translate(-328.141 -315.542)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M479.335,492.164h0Z",
    transform: "translate(-446.751 -458.708)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M352.264,338.693q0-.067-.005-.135h0q0,.064,0,.129Z",
    transform: "translate(-328.313 -315.544)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M479.17,492.164l-.022,0,.012,0h.01",
    transform: "translate(-446.577 -458.708)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M352.282,340.391l.024,0-.02.01s0-.005,0-.005",
    transform: "translate(-328.335 -317.247)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M521.034,292.932l-.015.019.008-.016.007,0",
    transform: "translate(-485.601 -273.019)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M441.39,486.47l.018.01h-.013a.057.057,0,0,1,0-.009",
    transform: "translate(-411.385 -453.401)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M433.234,528.209l-.022-.007.012.01.01,0",
    transform: "translate(-403.763 -492.296)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M350.178,352.879c0,.037,0,.073,0,.11l.005.008c0-.041,0-.082,0-.124l0,.006",
    transform: "translate(-326.371 -328.886)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M584.73,71.79l-.006-.006Z",
    transform: "translate(-544.976 -66.904)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M584.134,69.962l.041-.133-.084.01v-.006l.049.134-.007-.005",
    transform: "translate(-544.386 -65.082)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M583.966,69.666l-.009-.022.009.017v.006",
    transform: "translate(-544.261 -64.91)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M385.5,354.609q0,.08,0,.161h0q0-.079,0-.158h0",
    transform: "translate(-359.296 -330.504)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M424.347,2.7l.006.022-.014-.016.008-.005",
    transform: "translate(-395.493 -2.519)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M377,411.324l0-.006,0,.006",
    transform: "translate(-351.376 -383.358)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M373.874,411.266v.005l.007,0-.007-.007",
    transform: "translate(-348.459 -383.309)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M533.646,355.061l.1-.11s-.006-.007-.006-.008l-.1.11.006.007",
    transform: "translate(-497.364 -330.816)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M569.277,699.794l.664-.069q-.005-.088-.01-.176l-.642.084a6.38,6.38,0,0,1-1.305.152c-.961-.081-1.914-.246-2.87-.375-.442-.06-.884-.125-1.327-.173-.574-.062-1.15-.108-1.724-.162a1.028,1.028,0,0,1-.161-.019c0-.5-.011-.995.034-1.488.006-.064.3-.161.453-.143,1.245.149,2.488.323,3.731.485.192.025.386.026.58.039.024-.426.051-.852.066-1.278,0-.03-.1-.1-.116-.088a.258.258,0,0,0-.119.142,1.687,1.687,0,0,0-.065.533c.066.487-.238.471-.556.442-.747-.068-1.494-.144-2.241-.216-.022,0-.064,0-.065,0-.041-.421-.1-.843-.1-1.265,0-.078.231-.237.341-.225,1.6.172,3.2.365,4.794.557.389.047.781.093,1.163.175a.359.359,0,0,1,.209.277c-.017.347-.12.693-.11,1.037,0,.142.189.319.336.4.1.059.284-.027.428-.02.755.036.776.342.684,1.069-.107.851-.52.573-.975.528-.362-.036-.73-.007-1.1-.007q0-.111,0-.222m-4.122-2.66c.431.29.7.234.7-.343a.726.726,0,0,0-.085-.231c-.062.064-.126.127-.186.192s-.1.129-.16.182c-.084.076-.178.141-.268.21l-.356-.633-.435.463c.2.064.392.134.592.187a.511.511,0,0,0,.2-.029m4.234,0-.325-.144c-.028.16-.061.32-.083.481-.038.276-.069.553-.1.83a5.6,5.6,0,0,1-1.033-.154c-.08-.026-.07-.376-.075-.578s.031-.382.034-.574c0-.051-.055-.1-.085-.155-.053.033-.146.06-.153.1a1.379,1.379,0,0,0-.059.622c.115.339.025.434-.3.427-.076,0-.153.089-.23.136.05.058.089.147.152.169a9.022,9.022,0,0,1,.9.292,1.525,1.525,0,0,0,1.484-.287c-.1-.131-.255-.243-.258-.359a4.484,4.484,0,0,1,.135-.809m-1.1,2.352a4.324,4.324,0,0,1,1.36-.325,4.475,4.475,0,0,1,1.281.558c.029.013.087.023.1.01a.838.838,0,0,0,.08-.166,5.691,5.691,0,0,0-1.523-.747c-.4-.072-.874.222-1.309.369-.075.025-.123.128-.184.2l.2.107m-5.191-.885.193.435c.083-.178.171-.353.247-.534a1.681,1.681,0,0,0,.089-.314c.013-.066.034-.167,0-.2a1.817,1.817,0,0,0-.3-.2.878.878,0,0,0-.124.214c-.04.163-.058.332-.1.6m3.7-.057-.269-.224a6.289,6.289,0,0,0-.244.691c-.016.066.1.164.155.247l.357-.714m-2.881.444.228.009c.021-.313.045-.625.059-.938a.153.153,0,0,0-.077-.124c-.042-.01-.137.03-.14.055-.031.332-.049.665-.071,1m2.11-.52-.211-.241c-.06.246-.128.491-.175.74-.01.053.058.121.09.182l.3-.681m-.7-.294c-.068.3-.126.546-.164.79a1.072,1.072,0,0,0,.231.089,3.5,3.5,0,0,0,.09-.576c0-.1-.1-.2-.157-.3m1.874.594h-.186l-.03.49a1.4,1.4,0,0,0,.207-.011c.013-.159.009-.319.009-.479m-3.359-1.689.121.01.08-.7-.167-.01-.034.7m6.868,1.6-.066.14c.163.07.325.139.49.2a.836.836,0,0,0,.048-.1c-.156-.084-.314-.162-.472-.241m-8.135-.391.131.01.053-.343-.184-.013ZM567.6,699.3l.125-.028-.066-.232-.091.018.032.242m-4.98-.558c.024-.034.056-.059.053-.078s-.035-.044-.055-.066c-.019.021-.052.041-.053.064s.029.046.055.081m2.118-.416c.008,0,.019-.006.022-.013s0-.016,0-.024l-.035.021.018.016m2.576-1.445a.419.419,0,0,0-.027.054s.02.019.025.017a.3.3,0,0,0,.048-.032l-.046-.039",
    transform: "translate(-523.703 -648.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M771.929,673.9c-.075-.107-.172-.314-.22-.3a1.038,1.038,0,0,0-.548.252,4,4,0,0,0-.409.793c.814-.181.973.24.86.827-.035.185-.257.473-.386.468a1.183,1.183,0,0,1-.594-.35c-.342-.289-.285-.577-.2-1.033a1.849,1.849,0,0,1,1.092-1.59c.11-.048.178-.209.247-.328.1-.183.15-.428.3-.552a2.436,2.436,0,0,1,.661-.281,4.647,4.647,0,0,0,.06.488c.1.457.224.911.325,1.368.02.09.006.265-.031.277-.66.213,0,.376.007.562a9.569,9.569,0,0,1,.021,1.581c-.076.713-.646.447-1.055.422-.077,0-.2-.238-.2-.368a9.214,9.214,0,0,1,.06-1.027.249.249,0,0,1,.085-.119,3.45,3.45,0,0,1,.354.226c.124.092.239.2.358.3-.025-.184-.05-.369-.074-.553-.013-.1-.018-.2-.033-.3a2.014,2.014,0,0,0-.087-.446,1.933,1.933,0,0,0-.243-.355l.492-.12-.135-.405-.718.563.008.007m.75-1.44-.179-.127-.692,1.022.2.133.676-1.028m-1.826,2.78a1.919,1.919,0,0,0,.321-.033.745.745,0,0,0,.175-.112c-.091-.063-.188-.182-.273-.174-.115.011-.222.118-.332.184l.109.135m1.636,1.107.176.049.118-.487-.121-.033-.173.472m-1.512-.9-.009.133h.349l0-.108-.343-.025m1.253.4.042.036c0-.009.016-.023.013-.028a.241.241,0,0,0-.037-.037l-.017.028",
    transform: "translate(-718.001 -626.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M158.125,513.594a5.648,5.648,0,0,0,.726.118,1.364,1.364,0,0,0,.63-.087c.33-.162.649-.7.845.145.027.118.607.11.932.155.179.025.359.038.539.057-.134.108-.266.219-.4.322-.092.069-.282.147-.273.189a1.436,1.436,0,0,0,.209.491,7.043,7.043,0,0,0,.444.55c-.189-.061-.374-.138-.567-.181-.646-.145-1.3-.27-1.942-.42a1.632,1.632,0,0,1-.378-.2,2.459,2.459,0,0,0,.334-.144,7.275,7.275,0,0,0,.747-.5c.046-.037.008-.213-.031-.309-.023-.055-.125-.078-.192-.115-.034.088-.042.211-.106.256a6.341,6.341,0,0,1-.738.444c-.011.006-.1-.207-.191-.267a6.725,6.725,0,0,0-.6-.335l.016-.164",
    transform: "translate(-147.361 -478.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M212.853,727.052a13.173,13.173,0,0,0-.37-1.265c-.057-.147-.3-.344-.422-.325-2.307.346-4.609.726-6.915,1.082a3.119,3.119,0,0,1-.719-.055,2.807,2.807,0,0,1,.634-.272c2.337-.375,4.677-.731,7.016-1.1.349-.055.577-.031.625.412a9.131,9.131,0,0,0,.29,1.111,1.71,1.71,0,0,1,0,.389l-.142.021",
    transform: "translate(-190.53 -675.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M247.71,480.857a.86.86,0,0,1,.739.827c.016.127.2.232.313.347-.051.031-.128.1-.15.087a3.383,3.383,0,0,1-.469-.352c-.053-.05-.053-.157-.078-.239-.055.016-.094.025-.094.027.114.677-.642.489-.852.85-.035.06-.171.061-.26.089a.787.787,0,0,1-.044-.279c.116-.505-.214-.651-.593-.775a3.575,3.575,0,0,1-.407-.19c.134-.05.266-.105.4-.15.393-.13.81-.234.652-.814-.017-.062.056-.209.1-.213a.372.372,0,0,1,.293.077c.3.41.6.716,1.145.362.057-.037.206.045.3.1a.2.2,0,0,1-.008.175.646.646,0,0,1-.275.071c-.236.009-.473,0-.709,0m-.111.931.02-.191-.6-.053-.006.152.587.092",
    transform: "translate(-229.106 -447.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M209.336,504.659c-.257.017-.444.087-.515.024-.391-.343-.344.044-.443.232a1.649,1.649,0,0,1-.268.3c-.041-.132-.081-.265-.122-.4a2.812,2.812,0,0,1-.108-.349c-.031-.181-.042-.365-.068-.612a2.938,2.938,0,0,1-.517.027c-.1-.008-.184-.118-.275-.181.083-.062.158-.156.251-.18a12.582,12.582,0,0,1,1.6-.367,5.2,5.2,0,0,1,1.154.088c.036,0,.1.1.091.118-.045.07-.11.176-.173.18-.329.018-.659.008-1.013.008.036.047.064.122.1.127.517.062.648.479.81.867.056.134.094.276.14.415-.085,0-.2.041-.248,0a2.774,2.774,0,0,1-.352-.42c-.109-.151-.193-.321-.313-.462-.028-.033-.157.021-.239.036a.956.956,0,0,0,.116.2c.09.094.195.173.394.346m-.764-.328.232-.242a2.5,2.5,0,0,0-.375-.088c-.043,0-.094.075-.141.115l.284.214",
    transform: "translate(-192.947 -468.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M449.386,795.185c-.171-.147-.439-.27-.483-.448-.036-.144.215-.517.308-.507a1.741,1.741,0,0,1,.88.332c.092.074,0,.483-.117.66-.057.083-.389-.024-.6-.045l.468-.4-.3-.2c-.063.161-.131.321-.187.484-.013.037.014.087.023.131",
    transform: "translate(-418.384 -740.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M244.432,754.623l-.176-.21c.07-.053.133-.139.211-.155.478-.094.958-.172,1.438-.255.022,0,.044-.023.064-.02.237.041.473.084.709.127a2.941,2.941,0,0,1-.57.242c-.528.1-1.064.175-1.675.271",
    transform: "translate(-227.652 -702.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M283.091,750.768l-.181-.227a2.319,2.319,0,0,1,.3-.159,1.468,1.468,0,0,1,.384-.094,1.694,1.694,0,0,1,.48.023c.046.01.067.143.1.22a3.777,3.777,0,0,1-.391.127c-.2.042-.4.066-.688.111",
    transform: "translate(-263.678 -699.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M784.32,702.558l.3.439c.068.1.136.193.2.289-.11,0-.241.041-.326-.005a2.455,2.455,0,0,1-.831-.685l.656-.03-.008-.007",
    transform: "translate(-730.4 -654.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M272.7,739.658c-.152.176-.271.409-.364.4-.151-.016-.285-.192-.426-.3.177-.1.351-.209.536-.291.033-.014.115.085.253.193",
    transform: "translate(-253.427 -689.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M184.015,538.69c.142.282.28.436.246.514a2.383,2.383,0,0,1-.371.487c-.05-.07-.153-.152-.14-.207.051-.217.138-.426.265-.795",
    transform: "translate(-171.258 -502.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M224.7,494.249a1.262,1.262,0,0,1-.2-.4c-.006-.081.122-.171.19-.258a2.52,2.52,0,0,1,.305.378c.013.023-.157.149-.3.276",
    transform: "translate(-209.244 -460.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M790.058,653.271a4.18,4.18,0,0,1-.52.307c-.029.012-.183-.148-.169-.184a.935.935,0,0,1,.244-.346c.028-.024.167.08.445.223",
    transform: "translate(-735.709 -608.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M257.178,743.236l-.342-.3a1.432,1.432,0,0,1,.374-.181c.064-.011.151.109.228.17l-.26.307",
    transform: "translate(-239.377 -692.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M414.7,559.7c-.138-.216-.28-.429-.406-.651-.013-.023.066-.1.1-.151l.522.591Z",
    transform: "translate(-386.133 -520.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M306.907,481.456c.075.1.159.167.146.2a.955.955,0,0,1-.161.224c-.053-.061-.145-.12-.149-.184s.083-.129.164-.24",
    transform: "translate(-285.892 -448.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M252.116,484.2l.214-.355.119.07-.209.358-.124-.072",
    transform: "translate(-234.978 -450.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M164.42,550.431h.38l.006.094-.379.033-.007-.127",
    transform: "translate(-153.243 -513.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M402.11,550.772l.273.21-.067.094-.288-.2.082-.108",
    transform: "translate(-374.699 -513.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M456.694,655.682l.3.2-.063.095-.315-.2.076-.094",
    transform: "translate(-425.578 -611.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M176.715,543.365l.181.155-.062.082-.2-.14.077-.1",
    transform: "translate(-164.631 -506.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M196.669,547.213c-.052-.066-.1-.1-.1-.14s.033-.069.052-.1c.042.026.105.043.121.08s-.032.084-.068.163",
    transform: "translate(-183.201 -509.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M451.123,662.481l-.014-.236.111-.012.039.239-.136.01",
    transform: "translate(-420.444 -617.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M304.692,475.19l.17.194-.069.058-.159-.2.058-.049",
    transform: "translate(-283.926 -442.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M195.935,516.012l.194.049-.015.061-.195-.049.015-.061",
    transform: "translate(-182.602 -480.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M363.528,816.672c.091.167.13.207.124.236a.111.111,0,0,1-.092.063.132.132,0,0,1-.074-.093.783.783,0,0,1,.042-.207",
    transform: "translate(-338.775 -761.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M158.386,551.681l-.06-.082.1-.057c.014.026.044.057.038.078s-.045.037-.077.061",
    transform: "translate(-147.563 -514.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M391.218,528.335l-.015.025a.443.443,0,0,1-.041-.027.091.091,0,0,1,.013-.022.3.3,0,0,1,.043.024",
    transform: "translate(-364.572 -492.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M208.973,554.769c-.02.008-.039.024-.054.021s-.021-.027-.032-.042c.018-.008.036-.023.052-.02s.022.026.034.042",
    transform: "translate(-194.687 -517.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M307.971,501.693l-.053.026a.325.325,0,0,1-.008-.057c0-.005.023-.016.026-.014a.348.348,0,0,1,.036.045",
    transform: "translate(-286.978 -467.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M785.154,629.523c.007.036.015.072,0-.009.009.081,0,.044,0,.005,0,0,0,0,0,0",
    transform: "translate(-731.779 -586.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M382.288,532.4l.022,0-.008.021Z",
    transform: "translate(-356.301 -496.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M724.208,539.535l.051-.021a.081.081,0,0,1-.017.011l-.028.007-.006,0",
    transform: "translate(-674.978 -502.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M339.578,163.593l-.461-.306c.155-.07.2-.11.251-.11.873,0,1.747-.022,2.618.016.82.035,1.637.153,2.457.2.318.017.664-.167.956-.094a7.472,7.472,0,0,1,1.416.589c.091.044.111.233.164.355a2.54,2.54,0,0,1-.594.154c-1.2.017-2.393.015-3.59.014-.156,0-.313-.056-.469-.053-.779.014-1.558.055-2.336.05a6.458,6.458,0,0,1-.926-.148,2.708,2.708,0,0,0-.364-.027c-.336-.006-.672-.017-1.008-.008-.293.008-.585.053-.878.056-.166,0-.332-.07-.5-.073-.656-.013-1.311-.005-1.967-.019-.893-.019-1.786-.049-2.678-.078a3.616,3.616,0,0,1-.569-.046,1.544,1.544,0,0,1-.343-.158c.066-.106.109-.246.2-.313a4.021,4.021,0,0,1,2.668-.489c.055,0,.11.039.164.037.982-.035,1.965-.115,2.946-.1a4.007,4.007,0,0,1,2.418.515,1.22,1.22,0,0,0,.372.112l.048-.072m-8.221,0-.008.271a18.082,18.082,0,0,0,2.724-.027,24.947,24.947,0,0,1,3.659.086c.572-.006,1.144,0,1.815,0a32.361,32.361,0,0,0-8.19-.33m9.342.169-.007.142h5.53q0-.071,0-.142Zm-.279.365.064-.162-.628-.252-.075.172.639.242",
    transform: "translate(-308.276 -151.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M434.141,83.349c.08.046.674-.073.177.415a3.026,3.026,0,0,0,.4.379c.091.061.256.015.344.078a.3.3,0,0,1,.063.286c-.1.157-.236.382-.382.4a13.518,13.518,0,0,1-2.155.176c-.3-.007-.586-.294-.878-.454.071-.12.134-.337.215-.344.384-.033.774,0,1.161-.011.087,0,.172-.094.258-.144-.086-.057-.166-.15-.258-.164-.3-.047-.607-.043-.9-.1-.137-.028-.252-.162-.377-.248.131-.05.259-.107.393-.147s.277-.067.415-.1c-.121-.055-.241-.112-.363-.165a.58.58,0,0,0-.1-.019,9.315,9.315,0,0,1,.161-1.017c.009-.035.289.007.441-.008s.312-.058.468-.085c.228-.039.54-.184.665-.088a1.344,1.344,0,0,1,.384.72c.042.171-.071.38-.131.641m-.285-.018-.345.281.481.524.117-.063-.253-.742m.059,1.34-.052-.219-.765.187c.036.047.077.138.109.135.237-.024.473-.066.708-.1m-.679-1.715-.359-.474c-.063.079-.194.18-.177.233a.668.668,0,0,0,.24.319c.048.034.176-.044.3-.079",
    transform: "translate(-402.362 -76.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M424.178,151.2l1.352.158c.253.029.506.056.758.083l-.018.184h-2.061a1.32,1.32,0,0,1-.381-.006c-.3-.094-.582-.224-.876-.328s-.618-.2-.946-.309h3.119q0,.077.007.155l-.947.07-.019.011.011-.019m-.557.16c-.021-.026-.04-.057-.044-.056a.421.421,0,0,0-.07.047c.012.016.027.047.035.046a.341.341,0,0,0,.079-.037",
    transform: "translate(-393.319 -140.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M437.606,200.52a2.143,2.143,0,0,1-.228.364,5.651,5.651,0,0,1-.664-.347l-.01,0v-.084l0,.012.031-.136-.106.135,0-.009-.313-.276c.119-.126.235-.358.357-.361a14.52,14.52,0,0,1,1.575.079c.023,0,.072.228.043.246-.225.141-.465.256-.7.38l-.371-.263-.1.153.473.1",
    transform: "translate(-406.664 -186.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M484.728,155.371l2.374.37-.012.107-2.386-.283.024-.193",
    transform: "translate(-451.755 -144.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M348.27,151.132l-.579-.4c.07-.039.152-.124.208-.109.237.063.465.155.7.236l-.327.277",
    transform: "translate(-324.056 -140.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M328.4,189.564c-.345-.019-.69-.034-1.034-.062-.028,0-.075-.093-.066-.132s.075-.1.113-.1c.334.02.667.053,1,.082q-.007.107-.013.214",
    transform: "translate(-305.052 -176.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M336.768,183.857c.041-.01.086-.035.124-.027.211.047.421.1.631.153a.915.915,0,0,1-.029.114c-.251-.033-.5-.073-.75-.112l.024-.129",
    transform: "translate(-313.853 -171.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M563.023,241.677l.168-.655.15.035-.15.664-.168-.043",
    transform: "translate(-524.75 -224.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M405.9,223.93c-.059-.093-.137-.173-.122-.2a.876.876,0,0,1,.189-.187c.051.065.145.134.14.194s-.111.109-.208.194",
    transform: "translate(-378.193 -208.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M489.4,228.088c-.084.054-.138.116-.181.109s-.095-.073-.142-.114c.045-.038.089-.1.136-.105s.1.055.187.109",
    transform: "translate(-455.826 -212.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M540.953,154.308l-.345-.071.023-.113.342.08-.02.1",
    transform: "translate(-503.859 -143.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M318.669,189.549l.224.234-.094.088-.223-.235.093-.087",
    transform: "translate(-296.92 -176.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M424.338,156.727h-.225s0-.009,0-.014h.225s0,.009,0,.014",
    transform: "translate(-395.283 -146.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M527.7,162.033l-.261-.1.017-.034.24.129Z",
    transform: "translate(-491.585 -150.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M396.539,221.392l.049.095a.287.287,0,0,1-.082.029c-.012,0-.04-.038-.035-.048a.391.391,0,0,1,.069-.077",
    transform: "translate(-369.518 -206.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M515.474,131l0,.024-.018-.015Z",
    transform: "translate(-480.413 -122.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M406.143,187.037l-.018.018-.006-.024Z",
    transform: "translate(-378.511 -174.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M531.224,163.731l.026,0-.022.009s0,0,0,0",
    transform: "translate(-495.113 -152.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M440.955,209.269l-.077-.077,0,.009h.075l0-.012q0,.042,0,.084Z",
    transform: "translate(-410.904 -194.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M377.135,374.433l.137.159c-.052.044-.1.107-.158.123-.026.007-.107-.083-.108-.13s.072-.089.129-.152",
    transform: "translate(-351.378 -348.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M388.708,377.108h0",
    transform: "translate(-362.246 -351.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M414.789,380.3h.028l-.017.042c-.008-.006-.019-.01-.021-.017s.006-.017.01-.025",
    transform: "translate(-386.584 -354.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M440.222,383.624l.037.084-.04-.081,0,0",
    transform: "translate(-410.295 -357.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M358.277,369.692l-.031.006.026-.011s0,0,0,0",
    transform: "translate(-333.893 -344.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M497.266,379.389l.025,0-.021.009s0-.006,0-.006",
    transform: "translate(-463.463 -353.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M677.946,503.086c.12.436.234.8.313,1.176.015.072-.154.253-.163.248-.344-.192-.68-.4-1.016-.605a2.149,2.149,0,0,1,.253-.328,2.879,2.879,0,0,1,.385-.252c-.035-.039-.086-.118-.1-.111a1.951,1.951,0,0,0-.543.243c-.119.1-.143.3-.257.415a2.4,2.4,0,0,1-.466.288l.148-.6c-.188-.18-.472-.447-.747-.724-.044-.045-.047-.131-.069-.2a1.622,1.622,0,0,1,.246-.07,4.273,4.273,0,0,0,.74-.093c.093-.029.135-.233.189-.363a1.826,1.826,0,0,0,.067-.255c.085.038.22.054.249.118a1.28,1.28,0,0,0,1.2.913c.079,0,.156.148.234.228a1.955,1.955,0,0,1-.3.039,2.488,2.488,0,0,1-.356-.066",
    transform: "translate(-629.749 -467.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M646.285,490.885l-.219-.183c.082-.067.161-.182.246-.188s.158.114.237.178l-.265.193",
    transform: "translate(-602.148 -457.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M639.321,486.676l-.39-.095.01-.063.4.1-.019.057",
    transform: "translate(-595.498 -453.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M640.6,510.546c.034.032.069.049.071.069s-.028.045-.049.062c0,0-.044-.02-.045-.033a.378.378,0,0,1,.023-.1",
    transform: "translate(-597.03 -475.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M679.153,525.974l-.127-.164.04-.03.118.171-.031.023",
    transform: "translate(-632.867 -490.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M659.1,523.158a.274.274,0,0,1-.043.03c-.006,0-.018-.005-.026-.009l.02-.045.05.024",
    transform: "translate(-614.228 -487.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M438.795,315.7l-.238-.037.011-.07.246.037-.019.07",
    transform: "translate(-408.745 -294.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M595.805,473.164c-.4-.03-.736-.048-1.075-.088-.053-.006-.107-.1-.136-.168-.01-.023.06-.118.082-.115.346.059.69.126,1.033.2.026.006.04.069.1.172",
    transform: "translate(-554.174 -440.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M572.836,499.285h0",
    transform: "translate(-533.896 -465.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M561.837,498.285h0",
    transform: "translate(-523.645 -464.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M337.018,279.324l.005-.005-.005.005",
    transform: "translate(-314.108 -260.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M365.991,302.19l-.006-.005.006.005",
    transform: "translate(-341.107 -281.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M587.922,498.254h0",
    transform: "translate(-547.883 -464.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M346.289,226.4l.025,0-.021.009s0-.006,0-.006",
    transform: "translate(-322.749 -211.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M638.954,708.787a4.469,4.469,0,0,0-.135.809c0,.116.159.229.258.359a1.525,1.525,0,0,1-1.484.287,9.02,9.02,0,0,0-.9-.292c-.063-.022-.1-.111-.152-.169.077-.048.154-.138.23-.136.329.007.419-.087.3-.427a1.379,1.379,0,0,1,.059-.622c.007-.042.1-.068.153-.1.03.052.086.1.085.155,0,.192-.039.383-.034.574s-.005.552.075.578a5.588,5.588,0,0,0,1.033.154c.034-.277.065-.554.1-.83.022-.161.055-.32.083-.481l.325.144",
    transform: "translate(-593.268 -660.332)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M653.145,738.06l-.2-.107c.061-.067.109-.17.184-.2.435-.147.906-.44,1.309-.369a5.69,5.69,0,0,1,1.523.747.821.821,0,0,1-.08.166c-.009.013-.067,0-.1-.01a4.482,4.482,0,0,0-1.281-.558,4.328,4.328,0,0,0-1.36.326",
    transform: "translate(-608.56 -687.253)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M579.516,723.258c.043-.266.061-.435.1-.6a.872.872,0,0,1,.124-.214,1.815,1.815,0,0,1,.3.2c.034.032.013.133,0,.2a1.677,1.677,0,0,1-.089.314c-.076.181-.164.357-.247.534l-.193-.435",
    transform: "translate(-540.122 -673.336)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M598.935,704.223a.544.544,0,0,1-.2.027c-.2-.053-.395-.124-.592-.187l.435-.463.356.633Z",
    transform: "translate(-557.484 -655.77)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M626.9,730.484l-.358.714c-.055-.083-.171-.181-.155-.247a6.3,6.3,0,0,1,.244-.691l.269.224",
    transform: "translate(-583.809 -680.619)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M609.786,704.893c.09-.069.183-.134.268-.21.06-.053.1-.123.159-.182s.124-.128.186-.192a.727.727,0,0,1,.085.231c0,.577-.267.632-.7.344,0,0,0,.01,0,.01",
    transform: "translate(-568.334 -656.432)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M591.569,725.623c.021-.333.04-.666.07-1,0-.025.1-.065.14-.055a.154.154,0,0,1,.077.125c-.014.313-.038.625-.059.938l-.228-.009",
    transform: "translate(-551.356 -675.313)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M617.3,729.131l-.3.681c-.032-.061-.1-.129-.09-.182.047-.249.115-.494.175-.74l.211.241",
    transform: "translate(-574.981 -679.342)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M610.017,728.11c.058.1.158.2.157.3a3.49,3.49,0,0,1-.09.576,1.078,1.078,0,0,1-.232-.089c.038-.244.1-.485.164-.79",
    transform: "translate(-568.397 -678.615)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M636.873,736.84c0,.16,0,.32-.009.479a1.414,1.414,0,0,1-.207.011q.015-.245.03-.49Z",
    transform: "translate(-593.379 -686.751)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M590.42,702.391l.034-.7.167.01-.081.7-.121-.01",
    transform: "translate(-550.285 -653.991)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M690.557,735.6c.158.079.317.157.473.241a.83.83,0,0,1-.048.1c-.165-.064-.327-.134-.49-.2l.066-.14",
    transform: "translate(-643.553 -685.592)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M571.78,725.1v-.346l.184.013-.053.343-.131-.01",
    transform: "translate(-532.912 -675.491)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M645.355,741.1l-.032-.242.091-.018.066.232-.125.028",
    transform: "translate(-601.456 -690.479)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M571.769,734.468c-.026-.036-.056-.059-.055-.081s.034-.043.053-.064c.02.022.051.042.055.066s-.028.044-.053.078",
    transform: "translate(-532.851 -684.405)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M603.423,729.831l-.018-.016.035-.02c0,.008.008.018,0,.024s-.014.009-.022.013",
    transform: "translate(-562.387 -680.184)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M641.2,709.083l.046.039a.286.286,0,0,1-.048.032c-.005,0-.026-.014-.025-.017a.423.423,0,0,1,.027-.054",
    transform: "translate(-597.584 -660.881)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M792.4,679.731l-.676,1.028-.2-.133.692-1.022.179.127",
    transform: "translate(-737.726 -633.406)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M776,717.992l-.109-.135c.11-.066.217-.174.332-.184.085-.008.182.111.273.174a.748.748,0,0,1-.175.112,1.908,1.908,0,0,1-.321.033",
    transform: "translate(-723.151 -668.887)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M801.564,732.187l.173-.472.121.033-.118.487-.176-.049",
    transform: "translate(-747.076 -681.975)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M779.193,725.4l.343.025c0,.036,0,.072,0,.109h-.349q0-.066.009-.133",
    transform: "translate(-726.217 -676.09)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M797.756,730.937l.017-.028a.25.25,0,0,1,.037.037s-.008.018-.013.028l-.041-.037",
    transform: "translate(-743.526 -681.224)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M264.01,502l-.587-.092q0-.076.006-.152l.6.053-.02.191",
    transform: "translate(-245.516 -467.648)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M225.964,516.07l-.284-.214c.047-.041.1-.119.141-.115a2.5,2.5,0,0,1,.375.088l-.232.242",
    transform: "translate(-210.339 -480.682)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M455.7,799.858c-.009-.044-.036-.094-.023-.13.056-.164.124-.323.187-.484l.3.2-.468.4.009.008",
    transform: "translate(-424.694 -744.912)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M339.44,169.715a32.362,32.362,0,0,1,8.19.33c-.671,0-1.243,0-1.815,0a24.953,24.953,0,0,0-3.659-.086,18.089,18.089,0,0,1-2.724.027q0-.136.007-.271",
    transform: "translate(-316.359 -158.077)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M476.878,173.678H482.4l0,.142h-5.53l.007-.142",
    transform: "translate(-444.454 -161.872)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M464.1,173.38l-.639-.242.075-.172.628.252-.064.162",
    transform: "translate(-431.953 -161.208)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M458.584,102.187l.253.742-.117.063-.481-.524.345-.281",
    transform: "translate(-427.089 -95.241)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M452.98,118.9c-.236.037-.471.079-.708.1-.031,0-.072-.088-.109-.135l.765-.187.052.219",
    transform: "translate(-421.426 -110.616)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M446.83,90.184c-.119.035-.247.113-.3.079a.668.668,0,0,1-.24-.319c-.017-.053.113-.154.177-.233l.359.474",
    transform: "translate(-415.955 -83.612)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M444.2,155.769a.342.342,0,0,1-.079.037c-.008,0-.023-.03-.035-.046a.421.421,0,0,1,.07-.047s.024.029.044.056",
    transform: "translate(-413.895 -145.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M453.643,154.173l-.011.019.019-.011-.008-.008",
    transform: "translate(-422.784 -143.693)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M448.691,206.613l-.473-.1.1-.153.371.263.007-.007",
    transform: "translate(-417.749 -192.33)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M440.949,207.51h-.075l.106-.135-.031.136",
    transform: "translate(-410.904 -193.277)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M441.92,209.273c0-.028,0-.056,0-.084,0,.028,0,.056,0,.084",
    transform: "translate(-411.879 -194.969)",
    fill: "#1a1818"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.1f343eeeafdab400e00306a7ed324e7e.svg";
export { ForwardRef as ReactComponent };